export let dataEffects = {
    1: {
        img: "burning_flames",
        eng: "Burning Flames",
        rus: "Язычки пламени",
        schema: 13,
        pol: "palące płomienie",
        sch: "熊熊烈焰",
        fre: "Flammes brûlantes",
        bra: "Chamas ardentes",
        hun: "Lobogó lángok",
        swe: "Brinnande lågor"
    },
    2: {
        img: "circling_heart",
        eng: "Circling Heart",
        rus: "Кружащееся сердце",
        schema: 19,
        pol: "wirujące serce",
        sch: "旋转之心",
        fre: "Coeur tournant",
        bra: "Coração circulante",
        hun: "Keringő szív",
        swe: "Cirklande hjärta"
    },
    3: {
        img: "circling_peace_sign",
        eng: "Circling Peace Sign",
        rus: "Кружащийся знак мира",
        schema: 18,
        pol: "wirujący znak pokoju",
        sch: "旋转和平标志",
        fre: "Symbole Peace tournant",
        bra: "Símbolo de paz circulante",
        hun: "Keringő béke-jel",
        swe: "Cirklande fredstecken"
    },
    4: {
        img: "circling_tf_logo",
        eng: "Circling TF Logo",
        rus: "Кружащийся логотип TF",
        schema: 11,
        pol: "wirujące logo TF",
        sch: "旋转TF徽标",
        fre: "Logo TF tournant",
        bra: "Logo do TF circulante",
        hun: "Keringő TF logó",
        swe: "Cirklande TF-logotyp"
    },
    5: {
        img: "green_confetti",
        eng: "Green Confetti",
        rus: "Зелёное конфетти",
        schema: 6,
        pol: "zielone konfetti",
        sch: "绿色彩带",
        fre: "Confetti verts",
        bra: "Confete verde",
        hun: "Zöld konfetti",
        swe: "Grön konfetti"
    },
    6: {
        img: "green_energy",
        eng: "Green Energy",
        rus: "Зелёное свечение",
        schema: 9,
        pol: "zielona energia",
        sch: "绿色能量",
        fre: "Énergie verte",
        bra: "Energia verde",
        hun: "Zöld energia",
        swe: "Grön energi"
    },
    7: {
        img: "haunted_ghosts",
        eng: "Haunted Ghosts",
        rus: "Назойливые привидения",
        schema: 8,
        pol: "straszliwe duchy",
        sch: "灵魂附体",
        fre: "Fantômes",
        bra: "Fantasmas assombrados",
        hun: "Kísértő szellemek",
        swe: "Hemsökta spöken"
    },
    8: {
        img: "massed_flies",
        eng: "Massed Flies",
        rus: "Туча мух",
        schema: 12,
        pol: "chmara much",
        sch: "苍蝇云集",
        fre: "Cortège de mouches",
        bra: "Moscas em massa",
        hun: "Legyek",
        swe: "Flugsvärm"
    },
    9: {
        img: "purple_confetti",
        eng: "Purple Confetti",
        rus: "Пурпурное конфетти",
        schema: 7,
        pol: "fioletowe konfetti",
        sch: "紫色彩带",
        fre: "Confetti violets",
        bra: "Confete roxo",
        hun: "Lila konfetti",
        swe: "Lila konfetti"
    },
    10: {
        img: "purple_energy",
        eng: "Purple Energy",
        rus: "Пурпурное свечение",
        schema: 10,
        pol: "fioletowa energia",
        sch: "紫色能量",
        fre: "Énergie violette",
        bra: "Energia roxa",
        hun: "Lila energia",
        swe: "Lila energi"
    },
    11: {
        img: "scorching_flames",
        eng: "Scorching Flames",
        rus: "Опаляющее пламя",
        schema: 14,
        pol: "piekące płomienie",
        sch: "炉火纯青",
        fre: "Flammes écorcheuses",
        bra: "Chamas escaldantes",
        hun: "Perzselő lángok",
        swe: "Brännheta lågor"
    },
    12: {
        img: "searing_plasma",
        eng: "Searing Plasma",
        rus: "Выжигающая плазма",
        schema: 15,
        pol: "paląca plazma",
        sch: "剧烈离子体",
        fre: "Plasma brûlant",
        bra: "Plasma escaldante",
        hun: "Égető plazma",
        swe: "Glödande plasma"
    },
    13: {
        img: "sunbeams",
        eng: "Sunbeams",
        rus: "Солнечные лучи",
        schema: 17,
        pol: "promienie Słońca",
        sch: "太阳之光",
        fre: "Rayons de soleil",
        bra: "Raios de sol",
        hun: "Napsugarak",
        swe: "Solstrålar"
    },
    14: {
        img: "vivid_plasma",
        eng: "Vivid Plasma",
        rus: "Яркая плазма",
        schema: 16,
        pol: "żywa plazma",
        sch: "活泼离子体",
        fre: "Plasma éclatant",
        bra: "Plasma vívido",
        hun: "Élénk plazma",
        rom: "Plasmă Strălucitoare",
        swe: "Intensiv plasma"
    },
    15: {
        img: "72",
        eng: "'72",
        rus: "72-й",
        schema: 3004,
        pol: "1972",
        sch: "炫目舞会",
        fre: "'72",
        bra: "1972"
    },
    16: {
        img: "fountain_of_delight",
        eng: "Fountain of Delight",
        rus: "Фонтан желаний",
        schema: 3005,
        pol: "fontanna rozkoszy",
        sch: "快乐之源",
        fre: "Fontaine des Délices",
        bra: "Fonte do deleite",
        hun: "Élvezet szökőkútja",
        swe: "Glädjefontän"
    },
    17: {
        img: "holy_grail",
        eng: "Holy Grail",
        rus: "Святой Грааль",
        schema: 3003,
        pol: "Święty Graal",
        sch: "圣杯之光",
        fre: "Saint Graal",
        bra: "Santo Graal",
        hun: "Szent Grál",
        rom: "Sfântul Graal",
        swe: "Helig graal"
    },
    18: {
        img: "mega_strike",
        eng: "Mega Strike",
        rus: "Мега-удар",
        schema: 3010,
        pol: "megapiorun",
        sch: "超级闪电",
        fre: "Frappe foudroyante",
        bra: "Mega golpe",
        hun: "Mega csapás",
        swe: "Megaslag"
    },
    19: {
        img: "midnight_whirlwind",
        eng: "Midnight Whirlwind",
        rus: "Полуночный ураган",
        schema: 3008,
        pol: "północne tornado",
        sch: "午夜风暴",
        fre: "Tornade de minuit",
        bra: "Redemoinho da meia-noite",
        hun: "Éjféli forgószél",
        swe: "Midnattsvirvelvind"
    },
    20: {
        img: "screaming_tiger",
        eng: "Screaming Tiger",
        rus: "Ревущий тигр",
        schema: 3006,
        pol: "ryczący tygrys",
        sch: "火球环绕",
        fre: "Tigre hurlant",
        bra: "Tigre rugidor",
        hun: "Üvöltő tigris",
        swe: "Skrikande Tigern"
    },
    21: {
        img: "showstopper",
        eng: "Showstopper",
        rus: "Гвоздь программы",
        schema: 3001,
        pol: "fajerwerki",
        sch: "烟花表演",
        fre: "Clou du spectacle",
        bra: "Fim de show",
        hun: "Ünneprontó",
        swe: "Showstoppare"
    },
    22: {
        img: "silver_cyclone",
        eng: "Silver Cyclone",
        rus: "Серебристый циклон",
        schema: 3009,
        pol: "srebrny cyklon",
        sch: "白银旋风",
        fre: "Tornade d'argent",
        bra: "Ciclone prateado",
        hun: "Ezüst ciklon",
        swe: "Silvercyklon"
    },
    23: {
        img: "skill_gotten_gains",
        eng: "Skill Gotten Gains",
        rus: "Нечестное мастерство",
        schema: 3007,
        pol: "umiejętnie wycwaniona forsa",
        sch: "土豪光环",
        fre: "Biens bien acquis",
        bra: "Dinheiro sujo",
        hun: "Ügyesnek áll a világ",
        swe: "Erfaret förtjänta pengar"
    },
    24: {
        img: "isotope",
        eng: "Isotope",
        rus: "Изотоп",
        schema: 702,
        pol: "izotop",
        sch: "绿色辐射",
        fre: "Isotope",
        bra: "Isótopo",
        hun: "Izotóp",
        swe: "Isotop"
    },
    25: {
        img: "hot",
        eng: "Hot",
        rus: "Жар",
        schema: 701,
        pol: "żar",
        sch: "炽热发烟",
        fre: "Chaud",
        bra: "Quente",
        hun: "Forróság",
        swe: "Varm"
    },
    26: {
        img: "cool",
        eng: "Cool",
        rus: "Холод",
        schema: 703,
        pol: "chłód",
        sch: "冷若冰霜",
        fre: "Frais",
        bra: "Frio",
        hun: "Hűvösség",
        swe: "Kall"
    },
    27: {
        img: "energy_orb",
        eng: "Energy Orb",
        rus: "Энергетический шар",
        schema: 704,
        pol: "kula energii",
        sch: "能量光束",
        fre: "Orbe d'énergie",
        bra: "Orbe de energia",
        hun: "Energiagömb",
        swe: "Energiklot"
    },
    28: {
        img: "blizzardy_storm",
        eng: "Blizzardy Storm",
        rus: "Морозная метель",
        schema: 30,
        pol: "śnieżna zamieć",
        sch: "暴雪云",
        fre: "Tempête et Blizzard",
        bra: "Tempestade de neve",
        hun: "Hóvihar",
        swe: "Snöig Storm"
    },
    29: {
        img: "bubbling",
        eng: "Bubbling",
        rus: "Пузырьки",
        schema: 34,
        pol: "bąbelki",
        sch: "沤浮泡影",
        fre: "Bullant",
        bra: "Borbulhando",
        hun: "Buborékok",
        swe: "Bubblande"
    },
    30: {
        img: "nuts_n_bolts",
        eng: "Nuts n' Bolts",
        rus: "Болтики и гайки",
        schema: 31,
        pol: "śrubki i nakrętki",
        sch: "螺栓和螺母",
        fre: "Écrous & Boulons",
        bra: "Porcas e parafusos",
        hun: "Anyák és csavarok",
        swe: "Muttrar å skruvar"
    },
    31: {
        img: "orbiting_fire",
        eng: "Orbiting Fire",
        rus: "Огненный шар",
        schema: 33,
        pol: "błędny ognik",
        sch: "火焰缠绕",
        fre: "Flamme en Orbite",
        bra: "Fogo orbitante",
        hun: "Keringő tűzcsóva",
        swe: "Kretsande eld"
    },
    32: {
        img: "orbiting_planets",
        eng: "Orbiting Planets",
        rus: "Планетарная система",
        schema: 32,
        pol: "układ planetarny",
        sch: "行星环绕",
        fre: "Planètes en Orbite",
        bra: "Planetas orbitantes",
        hun: "Keringő bolygók",
        swe: "Kretsande planeter"
    },
    33: {
        img: "smoking",
        eng: "Smoking",
        rus: "Дымок",
        schema: 35,
        pol: "dym",
        sch: "乌烟瘴气",
        fre: "Fumée",
        bra: "Fumante",
        hun: "Füstölgés",
        swe: "Rykande"
    },
    34: {
        img: "steaming",
        eng: "Steaming",
        rus: "Струя пара",
        schema: 36,
        pol: "para",
        sch: "蒸汽腾腾",
        fre: "Vapeur",
        bra: "Soltando vapor",
        hun: "Gőzölgés",
        swe: "Ångande"
    },
    35: {
        img: "stormy_storm",
        eng: "Stormy Storm",
        rus: "Грозная гроза",
        schema: 29,
        pol: "burzliwa burza",
        sch: "暴雨云",
        fre: "Tempête et Éclairs",
        bra: "Tempestade tempestuosa",
        hun: "Zápor-zivatar",
        swe: "Stormig Storm"
    },
    36: {
        img: "cauldron_bubbles",
        eng: "Cauldron Bubbles",
        rus: "Ядовитые пары",
        schema: 39,
        pol: "bąbelki z kociołka",
        sch: "魔埚气泡",
        fre: "Bulles de Chaudron",
        bra: "Bolhas de caldeirão",
        hun: "Bugyborékoló üst",
        swe: "Kittelbubblor"
    },
    37: {
        img: "cloudy_moon",
        eng: "Cloudy Moon",
        rus: "Мрачная луна",
        schema: 38,
        pol: "zachmurzony księżyc",
        sch: "乌云盖月",
        fre: "Lune voilée",
        bra: "Lua nublada",
        hun: "Felhős hold",
        swe: "Molnig måne"
    },
    38: {
        img: "eerie_orbiting_fire",
        eng: "Eerie Orbiting Fire",
        rus: "Жуткий огненный шар",
        schema: 40,
        pol: "straszliwy błędny ognik",
        sch: "妖娆灵焰",
        fre: "Sinistre flamme en orbite",
        bra: "Fogo assustador orbitante",
        hun: "Hátborzongató keringő tűz",
        swe: "Kuslig kretsande eld"
    },
    39: {
        img: "flaming_lantern",
        eng: "Flaming Lantern",
        rus: "Горящий фонарь",
        schema: 37,
        pol: "płonąca latarnia",
        sch: "火焰南瓜",
        fre: "Lanterne enflammée",
        bra: "Lanterna flamejante",
        hun: "Lángoló lámpás",
        swe: "Flammande lykta"
    },
    40: {
        img: "harvest_moon",
        eng: "Harvest Moon",
        rus: "Луна жатвы",
        schema: 45,
        pol: "urodzajny księżyc",
        sch: "牧场物语",
        fre: "Lune des moissons",
        bra: "Lua de colheita",
        hun: "Holdtölte",
        swe: "Skördemåne"
    },
    41: {
        img: "its_a_secret_to_everybody",
        eng: "It's a Secret to Everybody",
        rus: "Великая тайна",
        schema: 46,
        pol: "dla wszystkich jest to sekretem",
        sch: "潜影骷髅",
        fre: "C'est un secret pour tout le monde",
        bra: "É um segredo para todos",
        hun: "Senki sem tud róla",
        swe: "Det är en hemlighet för alla"
    },
    42: {
        img: "knifestorm",
        eng: "Knifestorm",
        rus: "Ножевой шторм",
        schema: 43,
        pol: "ostra ulewa",
        sch: "刀光剑影",
        fre: "Couteaunnerre",
        bra: "Tempestade de facas",
        hun: "Késvihar",
        swe: "Knivstorm"
    },
    43: {
        img: "misty_skull",
        eng: "Misty Skull",
        rus: "Туманный череп",
        schema: 44,
        pol: "tajemnicza czaszka",
        sch: "迷雾骷髅",
        fre: "Crâne mystique",
        bra: "Caveira nebulosa",
        hun: "Ködös koponya",
        swe: "Dimmig dödskalle"
    },
    44: {
        img: "stormy_13th_hour",
        eng: "Stormy 13th Hour",
        rus: "Дождливый 13-й час",
        schema: 47,
        pol: "trzynasta burzliwa godzina",
        sch: "诅咒风暴",
        fre: "Orage de la 13ᵉ heure",
        bra: "Décima terceira hora tempestuosa",
        hun: "Viharos 13. óra",
        swe: "Den stormiga 13:e timmen"
    },
    45: {
        img: "anti_freeze",
        eng: "Anti-Freeze",
        rus: "Антифриз",
        schema: 69,
        pol: "płyn chłodzący",
        sch: "冰霜之抵",
        fre: "Antigel",
        bra: "Anticongelante",
        hun: "Fagyálló",
        swe: "Antifrys"
    },
    46: {
        img: "electrostatic",
        eng: "Electrostatic",
        rus: "Статическое электричество",
        schema: 67,
        pol: "elektrostatyczność",
        sch: "静电火花",
        fre: "Électrostatique",
        bra: "Eletrostático",
        hun: "Elektrosztatikus",
        swe: "Elektrostatisk"
    },
    47: {
        img: "green_black_hole",
        eng: "Green Black Hole",
        rus: "Черно-зеленая дыра",
        schema: 71,
        pol: "zielona czarna dziura",
        sch: "绿色黑洞",
        fre: "Trou noir vert",
        bra: "Buraco negro verde",
        hun: "Zöld fekete lyuk",
        swe: "Grönt svart hål"
    },
    48: {
        img: "memory_leak",
        eng: "Memory Leak",
        rus: "Утечка памяти",
        schema: 65,
        pol: "wyciek pamięci",
        sch: "内存溢出",
        fre: "Fuite mémoire",
        bra: "Vazamento de memória",
        hun: "Memóriaszivárgás",
        rom: "Scurgere de memorie",
        swe: "Minnesläcka"
    },
    49: {
        img: "overclocked",
        eng: "Overclocked",
        rus: "Разогнанный процессор",
        schema: 66,
        pol: "podkręcenie",
        sch: "超频过度",
        fre: "Overclocké",
        bra: "Overclock",
        hun: "Tuningolt",
        swe: "Överklockad"
    },
    50: {
        img: "phosphorous",
        eng: "Phosphorous",
        rus: "Фосфористый",
        schema: 63,
        pol: "fosfor",
        sch: "磷火",
        fre: "Phosphorescent",
        bra: "Fosforoso",
        hun: "Foszforos",
        swe: "Fosforhaltigt"
    },
    51: {
        img: "power_surge",
        eng: "Power Surge",
        rus: "Скачок напряжения",
        schema: 68,
        pol: "przepięcie",
        sch: "电弧放射",
        fre: "Surtension",
        bra: "Surto de energia",
        hun: "Túlfeszültség",
        swe: "Energivåg"
    },
    52: {
        img: "roboactive",
        eng: "Roboactive",
        rus: "Робоактивный элемент",
        schema: 72,
        pol: "roboaktywność",
        sch: "机情紫露",
        fre: "Roboactif",
        bra: "Roboativo",
        hun: "Roboaktív",
        swe: "Roboaktiv"
    },
    53: {
        img: "sulphurous",
        eng: "Sulphurous",
        rus: "Сернистый",
        schema: 64,
        pol: "siarka",
        sch: "硫火",
        fre: "Sulfureux",
        bra: "Sulfuroso",
        hun: "Kénes",
        rom: "Sulfuros",
        swe: "Svavelaktig"
    },
    54: {
        img: "time_warp",
        eng: "Time Warp",
        rus: "Временной разлом",
        schema: 70,
        pol: "zakrzywienie czasu",
        sch: "时间扭曲",
        fre: "Distorsion temporelle",
        bra: "Viagem no tempo",
        hun: "Időhurok",
        swe: "Tidsförvrängning"
    },
    55: {
        img: "aces_high",
        eng: "Aces High",
        rus: "Козырные тузы",
        schema: 59,
        pol: "asy pik",
        sch: "头牌高悬",
        fre: "As des As",
        bra: "Ás de espadas",
        hun: "Magas ász",
        swe: "Flygande äss"
    },
    56: {
        img: "cloud_9",
        eng: "Cloud 9",
        rus: "Седьмое небо",
        schema: 58,
        pol: "niczym w niebie",
        sch: "魔心连环",
        fre: "Sur un petit nuage",
        bra: "Nuvem 9",
        hun: "Szívfelhő",
        swe: "Moln 9"
    },
    57: {
        img: "dead_presidents",
        eng: "Dead Presidents",
        rus: "Мертвые президенты",
        schema: 60,
        pol: "duży nominał",
        sch: "总统之殇",
        fre: "Présidents morts",
        bra: "Verdinhas",
        hun: "Halott elnökök",
        swe: "Döda presidenter"
    },
    58: {
        img: "disco_beat_down",
        eng: "Disco Beat Down",
        rus: "Ритмы диско",
        schema: 62,
        pol: "w błysku disco",
        sch: "疯狂迪斯科",
        fre: "Fièvre du Disco",
        bra: "Estouro bacana",
        hun: "Diszkóláz",
        swe: "Discokväll"
    },
    59: {
        img: "kill_a_watt",
        eng: "Kill-a-Watt",
        rus: "Уби-ватт",
        schema: 56,
        pol: "gigawat",
        sch: "金色电流",
        fre: "Wattueur",
        bra: "Eletromatador",
        hun: "Kilőwatt",
        swe: "Död-a-Watt"
    },
    60: {
        img: "miami_nights",
        eng: "Miami Nights",
        rus: "Ночной Майами",
        schema: 61,
        pol: "noce Miami",
        sch: "迈阿密之夜",
        fre: "Miami Nights",
        bra: "Noites de Miami",
        hun: "Miami éjszakák",
        swe: "Miaminätter"
    },
    61: {
        img: "terror_watt",
        eng: "Terror-Watt",
        rus: "Жутко-ватт",
        schema: 57,
        pol: "megawat",
        sch: "青色电流",
        fre: "Terreur-Watt",
        bra: "Eleterrorficado",
        hun: "Terrorwatt"
    },
    62: {
        img: "arcana",
        eng: "Arcana",
        rus: "Загадки",
        schema: 73,
        pol: "arkana",
        sch: "奥秘之髓",
        fre: "Arcane",
        bra: "Arcano",
        hun: "Titokzatos",
        swe: "Arkanisk"
    },
    63: {
        img: "chiroptera_venenata",
        eng: "Chiroptera Venenata",
        rus: "Ядовитус рукокрылус",
        schema: 75,
        pol: "chiroptera venenata",
        sch: "幽冥之火",
        fre: "Chiroptera Venenata",
        bra: "Chiroptera venenata",
        ger: "Giftige Fledermaus"
    },
    64: {
        img: "darkblaze",
        eng: "Darkblaze",
        rus: "Темное пламя",
        schema: 79,
        pol: "ciemny płomień",
        sch: "黑暗大火",
        fre: "Flammes maléfiques",
        bra: "Labareda sombria",
        hun: "Sötét láng",
        swe: "Mörk Eld"
    },
    65: {
        img: "demonflame",
        eng: "Demonflame",
        rus: "Демоническое пламя",
        schema: 80,
        pol: "demoniczny płomień",
        sch: "恶魔之火",
        fre: "Flammes démoniaques",
        bra: "Chama demoníaca",
        hun: "Démoni láng",
        swe: "Demonflamma"
    },
    66: {
        img: "hellfire",
        eng: "Hellfire",
        rus: "Адское пламя",
        schema: 78,
        pol: "piekielny ogień",
        sch: "地狱之焰",
        fre: "Flammes infernales",
        bra: "Fogo infernal",
        hun: "Pokoltűz",
        swe: "Helveteseld"
    },
    67: {
        img: "poisoned_shadows",
        eng: "Poisoned Shadows",
        rus: "Ядовитые тени",
        schema: 76,
        pol: "zatrute cienie",
        sch: "毒蕈之影",
        fre: "Ombre empoisonnée",
        bra: "Veneno sombrio",
        hun: "Mérgezett árnyak",
        swe: "Förgiftade skuggor"
    },
    68: {
        img: "something_burning_this_way_comes",
        eng: "Something Burning This Way Comes",
        rus: "Что-то жгучее грядет",
        schema: 77,
        pol: "jakiś płomień tu nadchodzi",
        sch: "炼狱之路",
        fre: "Ombre enflammée",
        bra: "Arder ou não arder",
        hun: "Lángoló lélek közeleg",
        swe: "Något brinnande hitåt ränner"
    },
    69: {
        img: "spellbound",
        eng: "Spellbound",
        rus: "Заклятье",
        schema: 74,
        pol: "urok",
        sch: "混乱魔咒",
        fre: "Envoutement",
        bra: "Feitiço de artifício",
        hun: "Varázsos",
        swe: "Trollbunden"
    },
    70: {
        img: "amaranthine",
        eng: "Amaranthine",
        rus: "Пурпур",
        schema: 82,
        pol: "amarant",
        sch: "不朽之灵",
        fre: "Amarante",
        bra: "Amarantino",
        hun: "Amaránt",
        swe: "Amarantin"
    },
    71: {
        img: "bonzo_the_all_gnawing",
        eng: "Bonzo the All-Gnawing",
        rus: "Всепоглощающий Бонзо",
        schema: 81,
        pol: "wszechjedzący Bonzo",
        sch: "地下巨口",
        fre: "Bonzo le rongeur de savoir",
        bra: "Bonzo, o atormentador",
        hun: "Bonzó, a Mindentrágó",
        swe: "Bonzo, den evigt gnagande"
    },
    72: {
        img: "ghastly_ghosts_jr",
        eng: "Ghastly Ghosts Jr",
        rus: "Малые жуткие призраки",
        schema: 85,
        pol: "młodsze upiorne upiory",
        fre: "Horribles fantômes Jr",
        sch: "紫色小鬼魂",
        bra: "Fantasminhas fantasmagóricos",
        hun: "Ifj. Szellemes szellemek",
        swe: "Gastande minigastar"
    },
    73: {
        img: "haunted_phantasm_jr",
        eng: "Haunted Phantasm Jr",
        rus: "Проклятый Призрак мл.",
        schema: 86,
        pol: "małe nawiedzone widziadło",
        sch: "青色小鬼魂",
        fre: "Fantôme hanteur Jr.",
        bra: "Fantasminha assombrado",
        hun: "ifj. Kísértő Látomás",
        swe: "Lilla hemsökande spöket"
    },
    74: {
        img: "stare_from_beyond",
        eng: "Stare From Beyond",
        rus: "Взгляд из бездны",
        schema: 83,
        pol: "spojrzenie z zaświatów",
        sch: "坟墓之眼",
        fre: "Regards de l'au-delà",
        bra: "Olhar do além",
        hun: "Túlvilági tekintet",
        swe: "Blicken från andra sidan"
    },
    75: {
        img: "ooze",
        eng: "Ooze",
        rus: "Слизь",
        schema: 84,
        pol: "szlam",
        sch: "泥中有眼",
        fre: "La Bourbe",
        bra: "O Pantanoso",
        hun: "A Nyálka",
        rom: "The Ooze",
        swe: "Slemmet"
    },
    76: {
        img: "death_at_dusk",
        eng: "Death at Dusk",
        rus: "Сумеречная смерть",
        schema: 90,
        pol: "śmierć o zmroku",
        sch: "落日",
        fre: "Mort crépusculaire",
        bra: "Morte ao anoitecer",
        hun: "Esti elmúlás",
        swe: "Solnedgång"
    },
    77: {
        img: "frostbite",
        eng: "Frostbite",
        rus: "Мороз",
        schema: 87,
        pol: "odmrożenie",
        sch: "寒霜",
        fre: "Engelure",
        bra: "Congelamento",
        hun: "Dércsípés",
        swe: "Köldskada"
    },
    78: {
        img: "molten_mallard",
        eng: "Molten Mallard",
        rus: "Пылающая птица",
        schema: 88,
        pol: "stopiona kaczka krzyżówka",
        sch: "鸭子焰火",
        fre: "Canartifice",
        bra: "Gratinado",
        hun: "Vörösizzó vadkacsa",
        swe: "Sprängd anka"
    },
    79: {
        img: "morning_glory",
        eng: "Morning Glory",
        rus: "Доброе утро",
        schema: 89,
        pol: "poranna chwała",
        sch: "晨曦",
        fre: "Splendeur matinale",
        bra: "Glória da manhã",
        hun: "Reggeli ragyogás",
        swe: "Soluppgång"
    },
    80: {
        img: "abduction",
        eng: "Abduction",
        rus: "Похищение",
        schema: 91,
        pol: "porwanie",
        sch: "吸收光束",
        fre: "Enlèvement",
        bra: "Abdução",
        hun: "Elrablás",
        swe: "Bortförande"
    },
    81: {
        img: "atomic",
        eng: "Atomic",
        rus: "Атомный",
        schema: 92,
        pol: "atomy",
        sch: "原子核",
        fre: "Atomique",
        bra: "Atômico",
        hun: "Atomi",
        swe: "Atomisk"
    },
    82: {
        img: "subatomic",
        eng: "Subatomic",
        rus: "Субатомный",
        schema: 93,
        pol: "subatomy",
        sch: "亚原子粒子",
        fre: "Subatomique",
        bra: "Subatômico",
        hun: "Szubatomi",
        swe: "Subatomär"
    },
    83: {
        img: "electric_hat_protector",
        eng: "Electric Hat Protector",
        rus: "Электрический защитник",
        schema: 94,
        pol: "elektryczna bariera ochronna",
        sch: "电弧保护罩",
        fre: "Protection électrique",
        bra: "Protetor elétrico de chapéus",
        hun: "Elektromos sapkavédő",
        swe: "Elektrisk hattskyddare"
    },
    84: {
        img: "magnetic_hat_protector",
        eng: "Magnetic Hat Protector",
        rus: "Магнетический защитник",
        schema: 95,
        pol: "magnetyczna bariera ochronna",
        sch: "磁能保护罩",
        fre: "Protection magnétique",
        bra: "Protetor magnético de chapéus",
        hun: "Mágneses sapkavédő",
        swe: "Magnetisk hattskyddare"
    },
    85: {
        img: "voltaic_hat_protector",
        eng: "Voltaic Hat Protector",
        rus: "Гальванический защитник",
        schema: 96,
        pol: "galwaniczna bariera ochronna",
        sch: "高压保护罩",
        fre: "Protection voltaïque",
        bra: "Protetor voltaico de chapéus",
        hun: "Voltaikus sapkavédő",
        swe: "Spänning-hattskyddare"
    },
    86: {
        img: "galactic_codex",
        eng: "Galactic Codex",
        rus: "Галактический кодекс",
        schema: 97,
        pol: "kodeks galaktyczny",
        sch: "星际密码",
        fre: "Codex galactique",
        bra: "Códice galático",
        hun: "Galaktikus Kódex",
        swe: "Galaktiskt kodex"
    },
    87: {
        img: "ancient_codex",
        eng: "Ancient Codex",
        rus: "Древний кодекс",
        schema: 98,
        pol: "kodeks starożytnych",
        sch: "远古密码",
        fre: "Codex ancien",
        bra: "Códice ancestral",
        hun: "Ősi Kódex",
        swe: "Antikt kodex"
    },
    88: {
        img: "nebula",
        eng: "Nebula",
        rus: "Туманность",
        schema: 99,
        pol: "mgławica",
        sch: "星云",
        fre: "Nébuleuse",
        bra: "Nébula",
        hun: "Csillagköd",
        ger: "Nebel"
    },
    89: {
        img: "death_by_disco",
        eng: "Death by Disco",
        rus: "Смерть в стиле диско",
        schema: 100,
        pol: "śmierć w rytmie disco",
        sch: "骷髅蹦迪",
        fre: "Disco de la mort",
        bra: "Requebrando o esqueleto",
        hun: "Diszkó általi halál",
        swe: "Dog av Disco"
    },
    90: {
        img: "its_a_mystery_to_everyone",
        eng: "It's a Mystery to Everyone",
        rus: "Загадка для всех",
        schema: 101,
        pol: "dla wszystkich jest to tajemnicą",
        sch: "紫色幽灵",
        fre: "C'est un mystère pour tout le monde",
        bra: "É um mistério",
        hun: "Rejtély mindenki számára",
        swe: "Det är ett mysterium för alla"
    },
    91: {
        img: "its_a_puzzle_to_me",
        eng: "It's a puzzle to me",
        rus: "Я сам в шоке",
        schema: 102,
        pol: "zagadka dla mnie",
        sch: "绿色幽灵",
        fre: "C'est une énigme pour moi",
        bra: "É uma charada",
        hun: "Rejtély számomra",
        cze: "It's a puzzle to me ",
        rom: "It's a puzzle to me ",
        swe: "Det är en gåta för mig"
    },
    92: {
        img: "ether_trail",
        eng: "Ether Trail",
        rus: "Эфирный шлейф",
        schema: 103,
        pol: "ślad eteru",
        sch: "幽冥之痕",
        fre: "Trainée céleste",
        bra: "Rastro etéreo",
        hun: "Éteri csóva",
        swe: "Eterspår"
    },
    93: {
        img: "nether_trail",
        eng: "Nether Trail",
        rus: "Бесплотный шлейф",
        schema: 104,
        pol: "ślad piekieł",
        sch: "诡异之痕",
        fre: "Trainée infernale",
        bra: "Rastro sombrio",
        hun: "Alvilági csóva",
        swe: "Nedrespår"
    },
    94: {
        img: "ancient_eldritch",
        eng: "Ancient Eldritch",
        rus: "Первобытный ужас",
        schema: 105,
        pol: "prastare dziwactwo",
        sch: "远古邪灵",
        fre: "Feu Eldritch",
        bra: "Assombração ancestral",
        hun: "Ősi rémség",
        swe: "Uråldrigt Spöke"
    },
    95: {
        img: "eldritch_flame",
        eng: "Eldritch Flame",
        rus: "Дух пламени",
        schema: 106,
        pol: "nadprzyrodzony płomień",
        sch: "邪灵之焰",
        fre: "Flamme d'Eldritch",
        bra: "Chama ancestral",
        hun: "Rémséges láng",
        swe: "Spökeld"
    },
    96: {
        img: "neutron_star",
        eng: "Neutron Star",
        rus: "Нейтронная звезда",
        schema: 107,
        pol: "gwiazda neutronowa",
        sch: "中子星",
        fre: "Étoile à neutrons",
        bra: "Estrela de nêutron",
        hun: "Neutroncsillag",
        swe: "Neutronstjärna"
    },
    97: {
        img: "starstorm_slumber",
        eng: "Starstorm Slumber",
        rus: "Галактическая греза",
        schema: 110,
        pol: "gwieździsty sen",
        sch: "蓝色流星雨",
        fre: "Sommeil étoilé",
        bra: "Sonolência estelar",
        hun: "Csillagzáporos szunyókálás",
        swe: "Stjärnstormslummer"
    },
    98: {
        img: "starstorm_insomnia",
        eng: "Starstorm Insomnia",
        rus: "Галактическая бессонница",
        schema: 109,
        pol: "gwiaździsta bezsenność",
        sch: "绿色流星雨",
        fre: "Insomnie étoilée",
        bra: "Insônia estelar",
        hun: "Csillagzáporos álmatlanság",
        swe: "Stjärnstormsömnlöshet"
    },
    99: {
        img: "tesla_coil",
        eng: "Tesla Coil",
        rus: "Катушка Тесла",
        schema: 108,
        pol: "transformator Tesli",
        sch: "磁暴线圈",
        fre: "Bobine Tesla",
        bra: "Bobina de Tesla",
        hun: "Tesla-tekercs",
        swe: "Teslaspole"
    },
    100: {
        img: "brain_drain",
        eng: "Brain Drain",
        rus: "Мозготечка",
        schema: 111,
        pol: "drenaż mózgu",
        sch: "脑浆外泄",
        fre: "Fuite des cerveaux",
        bra: "Vazão cerebral",
        hun: "Agyszipka",
        swe: "Hjärntömning"
    },
    101: {
        img: "open_mind",
        eng: "Open Mind",
        rus: "Открытый разум",
        schema: 112,
        pol: "otwarty umysł",
        sch: "脑洞大开",
        fre: "Esprit ouvert",
        bra: "Mente aberta",
        hun: "Nyitott elme",
        swe: "Öppet sinne"
    },
    102: {
        img: "head_of_steam",
        eng: "Head of Steam",
        rus: "Паровая голова",
        schema: 113,
        pol: "parująca głowa",
        sch: "脑浆迸裂",
        fre: "À toute vapeur",
        bra: "Cabeça fervente",
        hun: "Gőzbugyor",
        swe: "Huvudvärk"
    },
    103: {
        img: "galactic_gateway",
        eng: "Galactic Gateway",
        rus: "Галактические врата",
        schema: 114,
        pol: "galaktyczne przejście",
        sch: "星界之门",
        fre: "Portail intergalactique",
        bra: "Noite nebulosa",
        hun: "Galaktikus átjáró",
        swe: "Galaktisk portal"
    },
    104: {
        img: "the_eldritch_opening",
        eng: "Eldritch Opening",
        rus: "Зловещий просвет",
        schema: 115,
        pol: "nadprzyrodzone przejście",
        sch: "神秘之门",
        fre: "Passage funeste",
        bra: "Limiar sobrenatural",
        hun: "A vérfagyasztó nyiladék",
        rom: "The Eldritch Opening",
        swe: "Kuslig skymning"
    },
    105: {
        img: "the_dark_doorway",
        eng: "Dark Doorway",
        rus: "Тёмный проход",
        schema: 116,
        pol: "mroczne przejście",
        sch: "黑暗之门",
        fre: "Voie lugubre",
        bra: "Portão da penumbra",
        hun: "A sötét kapu",
        rom: "The Dark Doorway",
        swe: "Mörk dörröppning"
    },
    106: {
        img: "ring_of_fire",
        eng: "Ring of Fire",
        rus: "Кольцо пламени",
        schema: 117,
        pol: "pierścień ognia",
        sch: "烈焰之环",
        fre: "Anneau de feu",
        bra: "Círculo de fogo",
        hun: "Tűzgyűrű",
        swe: "Eldring"
    },
    107: {
        img: "vicious_circle",
        eng: "Vicious Circle",
        rus: "Порочный круг",
        schema: 118,
        pol: "błędne koło",
        sch: "堕落邪环",
        fre: "Cercle vicieux",
        bra: "Círculo vicioso",
        hun: "Gonosz kör",
        swe: "Ond cirkel"
    },
    108: {
        img: "white_lightning",
        eng: "White Lightning",
        rus: "Белая молния",
        schema: 119,
        pol: "biała błyskawica",
        sch: "白光之环",
        fre: "Éclair étincelant",
        bra: "Relâmpago reluzente",
        hun: "Fehér fény",
        swe: "Vitt ljus"
    },
    109: {
        img: "omniscient_orb",
        eng: "Omniscient Orb",
        rus: "Всеведущий шар",
        schema: 120,
        pol: "kryształowa kula",
        sch: "全知之球",
        fre: "Orbe de l'omniscience",
        bra: "Orbe onisciente",
        hun: "Mindentudó gömb",
        swe: "Allvetande kula"
    },
    110: {
        img: "clairvoyance",
        eng: "Clairvoyance",
        rus: "Ясновидение",
        schema: 121,
        pol: "jasnowidzenie",
        sch: "全知之眼",
        fre: "Clairvoyance",
        bra: "Clarividência",
        hun: "Harmadik szem",
        swe: "Klärvoajans"
    },
    111: {
        img: "fifth_dimension",
        eng: "Fifth Dimension",
        rus: "Пятое измерение",
        schema: 122,
        pol: "piąty wymiar",
        fre: "Cinquième dimension",
        sch: "第五维度",
        bra: "Quinta dimensão",
        hun: "Ötödik dimenzió",
        swe: "Femte dimensionen"
    },
    112: {
        img: "vicious_vortex",
        eng: "Vicious Vortex",
        rus: "Вредный вихрь",
        schema: 123,
        pol: "występny wir",
        fre: "Vortex vicieux",
        sch: "邪恶漩涡",
        bra: "Turbilhão turbulento",
        hun: "Őrjítő örvény",
        swe: "Våldsam virvelvind"
    },
    113: {
        img: "menacing_miasma",
        eng: "Menacing Miasma",
        rus: "Мистические миазмы",
        schema: 124,
        pol: "makabryczny miazmat",
        fre: "Miasme menaçant",
        sch: "恶毒瘴气",
        bra: "Miasma medonho",
        hun: "Komisz kipárolgás",
        swe: "Mystisk miasma"
    },
    114: {
        img: "abyssal_aura",
        eng: "Abyssal Aura",
        rus: "Астральная аура",
        schema: 125,
        pol: "aura otchłani",
        fre: "Aura abyssale",
        sch: "深渊光环",
        bra: "Aura abissal",
        hun: "Alvilági aura",
        ger: "Abgrundtiefe Aura"
    },
    115: {
        img: "wicked_wood",
        eng: "Wicked Wood",
        rus: "Чудовищная чаща",
        schema: 126,
        pol: "nikczemny las",
        fre: "Forêt funeste",
        sch: "暗影之林",
        bra: "Madeira maligna",
        hun: "Borzasztó bozótos",
        swe: "Spökande skog"
    },
    116: {
        img: "ghastly_grove",
        eng: "Ghastly Grove",
        rus: "Роковая роща",
        schema: 127,
        pol: "upiorny gaj",
        fre: "Bosquet hanté",
        sch: "恐怖之林",
        bra: "Floresta fantasmagórica",
        hun: "Lidérces liget",
        swe: "Dunkel dunge"
    },
    117: {
        img: "mystical_medley",
        eng: "Mystical Medley",
        rus: "Загадочное зарево",
        schema: 128,
        pol: "mistyczna mieszanina",
        fre: "Mélange mystique",
        sch: "神秘之涌",
        bra: "Misto místico",
        hun: "Misztikus mindenféle",
        swe: "Mystisk magi"
    },
    118: {
        img: "ethereal_essence",
        eng: "Ethereal Essence",
        rus: "Духовная дымка",
        schema: 129,
        pol: "eteryczna esencja",
        fre: "Essence éthérée",
        sch: "飘渺之华",
        bra: "Essência etérea",
        hun: "Éteri esszencia",
        swe: "Eterisk essens"
    },
    119: {
        img: "twisted_radiance",
        eng: "Twisted Radiance",
        rus: "Спиральное сияние",
        schema: 130,
        pol: "pokrętne promieniowanie",
        fre: "Rayonnement rocambolesque",
        sch: "扭曲之辉",
        bra: "Espiral do resplendor",
        hun: "Rontó ragyogás",
        swe: "Strålande sken"
    },
    120: {
        img: "violet_vortex",
        eng: "Violet Vortex",
        rus: "Виноградный вихрь",
        schema: 131,
        pol: "wrzosowy wir",
        fre: "Vortex violet",
        sch: "紫色漩涡",
        bra: "Vórtice violeta",
        hun: "Ibolyaszín örvény",
        swe: "Violett virvelvind"
    },
    121: {
        img: "verdant_vortex",
        eng: "Verdant Vortex",
        rus: "Весенний вихрь",
        schema: 132,
        pol: "zielenisty wir",
        fre: "Vortex verdoyant",
        sch: "翠绿漩涡",
        bra: "Vórtice verdejante",
        hun: "Zöldellő örvény",
        swe: "Smaragdgrön storm"
    },
    122: {
        img: "valiant_vortex",
        eng: "Valiant Vortex",
        rus: "Волевой вихрь",
        schema: 133,
        pol: "wiśniowy wir",
        fre: "Vortex vaillant",
        sch: "英勇漩涡",
        bra: "Vórtice valoroso",
        hun: "Hősies örvény",
        swe: "Tapper turbulens"
    },
    123: {
        img: "sparkling_lights",
        eng: "Sparkling Lights",
        rus: "Сверкающие огоньки",
        schema: 134,
        pol: "migoczące światełka",
        fre: "Lumières étincelantes",
        sch: "浮游彩光",
        bra: "Brilho cintilante",
        hun: "Sziporkázó fények",
        swe: "Gnistrande ljus"
    },
    124: {
        img: "frozen_icefall",
        eng: "Frozen Icefall",
        rus: "Морозный ледопад",
        schema: 135,
        pol: "spadające sople",
        fre: "Chute de neige",
        sch: "冰瀑",
        bra: "Cascata congelada",
        hun: "Fagyott jégeső",
        swe: "Fallande istappar"
    },
    125: {
        img: "fragmented_gluons",
        eng: "Fragmented Gluons",
        rus: "Фрагментированные глюоны",
        schema: 136,
        pol: "rozproszone gluony",
        fre: "Gluons fragmentés",
        sch: "胶子",
        bra: "Glúons fragmentados",
        hun: "Töredezett gluonok",
        swe: "Fragmenterade gluoner"
    },
    126: {
        img: "fragmented_quarks",
        eng: "Fragmented Quarks",
        rus: "Фрагментированные кварки",
        schema: 137,
        pol: "rozproszone kwarki",
        fre: "Quarks fragmentés",
        sch: "夸克",
        bra: "Quarks fragmentados",
        hun: "Töredezett kvarkok",
        swe: "Fragmenterade kvarkar"
    },
    127: {
        img: "fragmented_photons",
        eng: "Fragmented Photons",
        rus: "Фрагментированные фотоны",
        schema: 138,
        pol: "rozproszone fotony",
        fre: "Photons fragmentés",
        sch: "光子",
        bra: "Fótons fragmentados",
        hun: "Töredezett fotonok",
        swe: "Fragmenterade fotoner"
    },
    128: {
        img: "defragmenting_reality",
        eng: "Defragmenting Reality",
        rus: "Дефрагментация реальности",
        schema: 139,
        pol: "defragmentacja rzeczywistości",
        fre: "Réalité défragmentée",
        sch: "现实重构",
        bra: "Desfragmentando a realidade",
        hun: "Valóság-töredezettségmentesítés",
        swe: "Defragmenterar verkligheten"
    },
    129: {
        img: "fragmenting_reality",
        eng: "Fragmenting Reality",
        rus: "Фрагментация реальности",
        schema: 141,
        pol: "fragmentacja rzeczywistości",
        fre: "Réalité fragmentée",
        sch: "现实解体",
        bra: "Fragmentando a realidade",
        hun: "Töredező valóság",
        swe: "Fragmenterar verkligheten"
    },
    130: {
        img: "refragmenting_reality",
        eng: "Refragmenting Reality",
        rus: "Перефрагментация реальности",
        schema: 142,
        pol: "refragmentacja rzeczywistości",
        fre: "Réalité réfragmentée",
        sch: "现实重组",
        bra: "Realidade refragmentada",
        hun: "Újratöredező valóság",
        swe: "Fragmenterar om verkligheten"
    },
    131: {
        img: "snowfalled",
        eng: "Snowfallen",
        rus: "Падающий снег",
        schema: 143,
        pol: "spadający śnieg",
        fre: "Neige tombée",
        sch: "雪花飘落",
        bra: "Nevasca",
        hun: "Behavazott",
        swe: "Snögnistrande"
    },
    132: {
        img: "snowblinded",
        eng: "Snowblinded",
        rus: "Слепящий снег",
        schema: 144,
        pol: "oślepiający śnieg",
        fre: "Aveuglé par la neige",
        sch: "茫茫大雪",
        bra: "Cortina de neve",
        hun: "Hóvakított",
        swe: "Snöbländande"
    },
    133: {
        img: "pyroland_daydream",
        eng: "Pyroland Daydream",
        rus: "Грёза Пироландии",
        schema: 145,
        pol: "pyrolandowy sen na jawie",
        fre: "Rêve de Pyroland",
        sch: "幻境迷梦",
        bra: "Sonhos da Pyrolândia",
        hun: "Piróföldi álmodozás",
        swe: "Dagdröm i Pyroland"
    },
    134: {
        img: "verdatica",
        eng: "Verdatica",
        rus: "Виридиатика",
        schema: 147,
        pol: "werdatyka",
        fre: "Verdatica",
        sch: "绿色流光",
        bra: "Verdático",
        hun: "Zöldellő",
        ger: "Verdatisch",
        swe: "Verdatika"
    },
    135: {
        img: "aromatica",
        eng: "Aromatica",
        rus: "Ароматика",
        schema: 148,
        pol: "aromatyka",
        fre: "Aromatica",
        sch: "橙色流光",
        bra: "Aromático",
        hun: "Aromás",
        ger: "Aromatisch",
        swe: "Aromatika"
    },
    136: {
        img: "chromatica",
        eng: "Chromatica",
        rus: "Хроматика",
        schema: 149,
        pol: "chromatyka",
        fre: "Chromatica",
        sch: "紫色流光",
        bra: "Cromático",
        hun: "Kromatikus",
        ger: "Chromatisch",
        swe: "Kromatisk"
    },
    137: {
        img: "prismatica",
        eng: "Prismatica",
        rus: "Призматика",
        schema: 150,
        pol: "pryzmatyka",
        fre: "Prismatica",
        sch: "蓝色流光",
        bra: "Prismático",
        hun: "Prizmatikus",
        ger: "Prismatisch",
        swe: "Prismatisk"
    },
    138: {
        img: "bee_swarm",
        eng: "Bee Swarm",
        rus: "Рой пчёл",
        schema: 151,
        pol: "pszczeli rój",
        fre: "Essaim d'abeilles",
        sch: "愤怒蜂群",
        bra: "Enxame de abelhas",
        hun: "Méhraj",
        swe: "Bisvärm"
    },
    139: {
        img: "frisky_fireflies",
        eng: "Frisky Fireflies",
        rus: "Озорные светлячки",
        schema: 152,
        pol: "świetliste świetliki",
        fre: "Lucioles lumineuses",
        sch: "欢跃萤火",
        bra: "Pirilampos pimpões",
        hun: "Játékos szentjánosbogarak",
        swe: "Eldiga eldflugor"
    },
    140: {
        img: "smoldering_spirits",
        eng: "Smoldering Spirits",
        rus: "Тлеющие духи",
        schema: 153,
        pol: "zapalone zjawy",
        fre: "Esprits espiègles",
        sch: "阴郁之灵",
        bra: "Espíritos espirituosos",
        hun: "Parázsló lelkecskék",
        ger: "Glühende Geister",
        swe: "Rykande andar"
    },
    141: {
        img: "wandering_wisps",
        eng: "Wandering Wisps",
        rus: "Блуждающие огоньки",
        schema: 154,
        pol: "wędrujące ogniki",
        fre: "Fées fêtardes",
        sch: "漫游萤火",
        bra: "Fogo-fátuo",
        hun: "Libbenő lidércek",
        swe: "Irrande irrbloss"
    },
    142: {
        img: "kaleidoscope",
        eng: "Kaleidoscope",
        rus: "Калейдоскоп",
        schema: 155,
        pol: "kalejdoskop",
        fre: "Kaléidoscope",
        sch: "万花筒",
        bra: "Caleidoscópio",
        hun: "Kaleidoszkóp",
        swe: "Kalejdoskop"
    },
    143: {
        img: "green_giggler",
        eng: "Green Giggler",
        rus: "Зелёные забавы",
        schema: 156,
        pol: "zielony zgrywus",
        fre: "Vert de peur",
        sch: "憨笑绿瓜",
        bra: "Verde de alegria",
        hun: "Zölden kacagó",
        swe: "Grönt garv"
    },
    144: {
        img: "laugh_o_lantern",
        eng: "Laugh-O-Lantern",
        rus: "Светильник смеха",
        schema: 157,
        pol: "śmiechobuzie",
        fre: "Rire citrouille",
        sch: "狂笑之瓜",
        bra: "Abóboras animadas",
        hun: "Rötyögő tök",
        swe: "Brandgult skratt"
    },
    145: {
        img: "plum_prankster",
        eng: "Plum Prankster",
        rus: "Пурпурный проказник",
        schema: 158,
        pol: "śliwkowy śmieszek",
        fre: "Raillerie violente",
        sch: "嘲笑紫瓜",
        bra: "Roxo de tanto rir",
        hun: "Lila hahota",
        swe: "Lila flabb"
    },
    146: {
        img: "pyroland_nightmare",
        eng: "Pyroland Nightmare",
        rus: "Кошмар Пироландии",
        schema: 159,
        pol: "koszmar z Pyrolandu",
        fre: "Cauchemar de Pyroland",
        sch: "幻境梦魇",
        bra: "Pesadelos da Pyrolândia",
        hun: "Piróföldi rémálom",
        swe: "Mardröm från Pyroland"
    },
    147: {
        img: "gravelly_ghoul",
        eng: "Gravelly Ghoul",
        rus: "Гравиевый гуль",
        schema: 160,
        pol: "żwirowy ghul",
        fre: "Goule pétrifiée",
        sch: "庄严石像鬼",
        bra: "Criatura de cascalho",
        hun: "Kőszellem",
        swe: "Grusgast"
    },
    148: {
        img: "vexed_volcanics",
        eng: "Vexed Volcanics",
        rus: "Взбешённый вулканит",
        schema: 161,
        pol: "wkurzający wulkanit",
        fre: "Goule volcanique",
        sch: "熔岩石像鬼",
        bra: "Vulto vulcânico",
        hun: "Vulkanikus zargató",
        swe: "Vulkanisk vrede"
    },
    149: {
        img: "gourdian_angel",
        eng: "Gourdian Angel",
        rus: "Тыква-хранитель",
        schema: 162,
        pol: "dynioł stróż",
        fre: "Citrouille flottante",
        sch: "守护之瓜",
        bra: "Abóbora angelical",
        hun: "Tökangyal",
        ger: "Kürbisengel",
        swe: "Kalebassängel"
    },
    150: {
        img: "pumpkin_party",
        eng: "Pumpkin Party",
        rus: "Тыквенная тусовка",
        schema: 163,
        pol: "dyniowa domówka",
        fre: "Fête de la citrouille",
        sch: "南瓜开会",
        bra: "Festa das abóboras",
        hun: "Tök jó buli",
        ger: "Kürbisparty",
        swe: "Pumpaparty"
    },
    151: {
        img: "blighted_snowstorm",
        eng: "Blighted Snowstorm",
        rus: "Проклятый буран",
        schema: 170,
        pol: "zniweczona burza śnieżna",
        hun: "Elátkozott hóvihar",
        bra: "Nevasca púrpura",
        fre: "Glace funèbre",
        ger: "Tobender Schneesturm",
        swe: "Härjande snöstorm"
    },
    152: {
        img: "distant_dream",
        eng: "Distant Dream",
        rus: "Далёкие дрёмы",
        schema: 168,
        pol: "odległy sen",
        bra: "Ilusão distante",
        hun: "Áhítatos ábránd",
        fre: "Rêve lointain",
        ger: "Ferner Traum",
        swe: "Avlägsen dröm"
    },
    153: {
        img: "divine_desire",
        eng: "Divine Desire",
        rus: "Великое влечение",
        schema: 167,
        pol: "boskie pożądanie",
        bra: "Desejo divino",
        hun: "Áhítatos áhítozás",
        fre: "Désir divin",
        ger: "Göttliches Verlangen",
        swe: "Gudomlig önskan"
    },
    154: {
        img: "frozen_fractals",
        eng: "Frozen Fractals",
        rus: "Синий снегопад",
        schema: 164,
        pol: "zamrożone fraktale",
        bra: "Fractais congelados",
        hun: "Fagyott fraktálok",
        fre: "Flocons glacés",
        ger: "Eiskristalle",
        swe: "Frysta fraktaler"
    },
    155: {
        img: "genus_plasmos",
        eng: "Genus Plasmos",
        rus: "Генус Плазмос",
        schema: 172,
        pol: "genus plasmos",
        fre: "Origine de la création"
    },
    156: {
        img: "lavender_landfall",
        eng: "Lavender Landfall",
        rus: "Лавандовый ледопад",
        schema: 165,
        pol: "lawendowa lawina",
        bra: "Flocos de lavanda",
        hun: "Levendula lebegés",
        fre: "Poudreuse violette",
        ger: "Lavendelfarbener Flockentanz",
        swe: "Lavender lavin"
    },
    157: {
        img: "mirthful_mistletoe",
        eng: "Mirthful Mistletoe",
        rus: "Отрадная омела",
        schema: 175,
        pol: "radosna jemioła",
        hun: "Felvidító fagyöngy",
        bra: "Visco vistoso",
        fre: "Gui festif",
        ger: "Heiterer Mistelzweig",
        swe: "Munter mistel"
    },
    158: {
        img: "pale_nimbus",
        eng: "Pale Nimbus",
        rus: "Бледный ореол",
        schema: 171,
        pol: "blada chmura",
        hun: "Halvány dicsfény",
        fre: "Nuage pâle",
        ger: "Graupelschauer",
        swe: "Blek nimbus"
    },
    159: {
        img: "serenus_lumen",
        eng: "Serenus Lumen",
        rus: "Серенус Люмен",
        schema: 173,
        pol: "serenus lumen",
        bra: "Serenum lumen",
        fre: "Lumière sereine"
    },
    160: {
        img: "special_snowfall",
        eng: "Special Snowfall",
        rus: "Медовая метель",
        schema: 166,
        pol: "specjalny śnieg",
        bra: "Flocos especiais",
        hun: "Szokatlan szállingózás",
        fre: "Neige d'exception",
        ger: "Ungewöhnlicher Schneefall",
        swe: "Säreget snöfall"
    },
    161: {
        img: "ventum_maris",
        eng: "Ventum Maris",
        rus: "Вентум Марис",
        schema: 174,
        pol: "ventum maris",
        bra: "Ventus maris",
        fre: "Vents et marées"
    },
    162: {
        img: "violent_wintertide",
        eng: "Violent Wintertide",
        rus: "Суровая зима",
        schema: 169,
        pol: "gwałtowna fala zimy",
        hun: "Heves hófergeteg",
        bra: "Vendaval violento",
        fre: "Blizzard",
        ger: "Stürmische Winterzeit",
        swe: "Våldsam vintertid"
    },
    163: {
        img: "resonation",
        eng: "Resonation",
        rus: "Резонанс",
        schema: 177,
        pol: "rezonowanie",
        bra: "Ressonância",
        hun: "Rezonancia",
        fre: "Résonance",
        swe: "Resonans",
        sch: "共鸣电光"
    },
    164: {
        img: "aggradation",
        eng: "Aggradation",
        rus: "Аграданс",
        schema: 178,
        pol: "agradacja",
        bra: "Agradação",
        hun: "Ingerencia",
        swe: "Aggradering",
        sch: "高能电光"
    },
    165: {
        img: "lucidation",
        eng: "Lucidation",
        rus: "Яснонанс",
        schema: 179,
        pol: "naświetlenie",
        bra: "Elucidação",
        hun: "Luminencia",
        fre: "Élucidation",
        swe: "Upplysande",
        sch: "明澈电光"
    },
    166: {
        img: "stunning",
        eng: "Stunning",
        rus: "Оглушение",
        schema: 180,
        pol: "ogłuszenie",
        bra: "Estonteante",
        hun: "Kábulatos",
        fre: "Stellaire",
        swe: "Fantastisk"
    },
    167: {
        img: "ardentum_saturnalis",
        eng: "Ardentum Saturnalis",
        rus: "Пылкус Сатурналис",
        schema: 181,
        sch: "璀璨星弦"
    },
    168: {
        img: "fragrancium_elementalis",
        eng: "Fragrancium Elementalis",
        rus: "Благоухатус Элементалис",
        schema: 182,
        sch: "迷离星弦"
    },
    169: {
        img: "reverium_irregularis",
        eng: "Reverium Irregularis",
        rus: "Вращатус Непостоянис",
        schema: 183,
        sch: "梦幻星弦"
    },
    170: {
        img: "perennial_petals",
        eng: "Perennial Petals",
        rus: "Вечное цветение",
        schema: 185,
        pol: "okwiaty",
        bra: "Pétalas perenes",
        hun: "Örökszép szirmok",
        fre: "Pétales pérennes",
        swe: "Fleråriga kronblad",
        sch: "花香常漫"
    },
    171: {
        img: "flavorsome_sunset",
        eng: "Flavorsome Sunset",
        rus: "Ароматный закат",
        schema: 186,
        pol: "bogaty zachód Słońca",
        bra: "Ocaso saboroso",
        hun: "Ízléses naplemente",
        fre: "Coucher de soleil pittoresque",
        swe: "Smakfull solnedgång",
        sch: "落幕余晖"
    },
    172: {
        img: "raspberry_bloom",
        eng: "Raspberry Bloom",
        rus: "Малиновый ореол",
        schema: 187,
        pol: "malinowy rozkwit",
        bra: "Explosão de framboesa",
        hun: "Málnavirág",
        fre: "Éclosion fruitée",
        swe: "Hallonblomster",
        sch: "华彩绽放"
    },
    173: {
        img: "iridescence",
        eng: "Iridescence",
        rus: "Переливчатость",
        schema: 188,
        pol: "iryzacja",
        bra: "Iridescência",
        hun: "Színjátszás",
        swe: "Regnbågsskimmer",
        sch: "虹彩萦绕"
    },
    174: {
        img: "tempered_thorns",
        eng: "Tempered Thorns",
        rus: "Роковые рога",
        schema: 189,
        pol: "zahartowane ciernie",
        hun: "Szolid szarvak",
        swe: "Härdade horn",
        bra: "Chifres temperados",
        fre: "Cornes canon",
        sch: "棘刺魔角"
    },
    175: {
        img: "devilish_diablo",
        eng: "Devilish Diablo",
        rus: "Дьявольский демон",
        schema: 190,
        pol: "diabelski pomiot",
        bra: "Diabo diabólico",
        hun: "Ördögi ördög",
        swe: "Diabolisk djävul",
        fre: "Diable démoniaque",
        sch: "赤炎魔角"
    },
    176: {
        img: "severed_serration",
        eng: "Severed Serration",
        rus: "Отвратные отростки",
        schema: 191,
        pol: "wyostrzone zmysły",
        hun: "Heves hegyesség",
        swe: "Tjusiga taggar",
        bra: "Saliência serrilhada",
        fre: "Perches pourpres",
        sch: "幽能魔角"
    },
    177: {
        img: "shrieking_shades",
        eng: "Shrieking Shades",
        rus: "Визжащие видения",
        schema: 192,
        pol: "wrzeszczące cienie",
        hun: "Sikoltó árnyak",
        swe: "Gapande gastar",
        bra: "Aparição aflita",
        fre: "Cris crâniens",
        sch: "鬼哭狼嚎"
    },
    178: {
        img: "restless_wraiths",
        eng: "Restless Wraiths",
        rus: "Беспокойные духи",
        schema: 193,
        pol: "niespokojne upiory",
        hun: "Nyugtalan lidércek",
        swe: "Osaliga andar",
        bra: "Assombro agitado",
        fre: "Apparitions agitées",
        sch: "惊神泣鬼"
    },
    179: {
        img: "infernal_wraith",
        eng: "Infernal Wraith",
        rus: "Души из преисподней",
        schema: 195,
        pol: "piekielne upiory",
        hun: "Pokoli lidérc",
        swe: "Infernaliska vålnader",
        bra: "Espíritos infernais",
        fre: "Spectres sulfureux",
        sch: "幽冥魂冠"
    },
    180: {
        img: "phantom_crown",
        eng: "Phantom Crown",
        rus: "Фантомный венец",
        schema: 196,
        pol: "widmowa korona",
        hun: "Fantomkorona",
        swe: "Fantomkrona",
        bra: "Coroa fantasmagórica",
        fre: "Couronne fantomatique",
        sch: "幻影魂冠"
    },
    181: {
        img: "ancient_specter",
        eng: "Ancient Specter",
        rus: "Древний дух",
        schema: 197,
        pol: "starożytne widmo",
        hun: "Ősi jelenés",
        swe: "Forntida spöke",
        bra: "Espectro ancestral",
        fre: "Spectres anciens",
        sch: "上古魂冠"
    },
    182: {
        img: "viridescent_peeper",
        eng: "Viridescent Peeper",
        rus: "Зеленоватый зодчий",
        schema: 198,
        pol: "zielonkawy podglądacz",
        hun: "Zöld kémlelő",
        swe: "Kusliga korpgluggar",
        bra: "Visão viridescente",
        fre: "Visage verdoyant",
        sch: "妒意凝视"
    },
    183: {
        img: "eyes_of_molten",
        eng: "Eyes of Molten",
        rus: "Огненный обзор",
        schema: 199,
        pol: "oczy stopionego",
        hun: "Izzó szemek",
        swe: "Brännande blick",
        bra: "Testemunha das chamas",
        fre: "Regard retors",
        sch: "灼怒凝视"
    },
    184: {
        img: "ominous_stare",
        eng: "Ominous Stare",
        rus: "Грозные глаза",
        schema: 200,
        pol: "złowieszcze spojrzenie",
        hun: "Baljós tekintet",
        swe: "Olycksbådande blick",
        bra: "Olhar odioso",
        fre: "Présence pesante",
        sch: "怪诞凝视"
    },
    185: {
        img: "pumpkin_moon",
        eng: "Pumpkin Moon",
        rus: "Тыквенная луна",
        schema: 201,
        pol: "dyniowy księżyc",
        hun: "Tökhold",
        swe: "Pumpamåne",
        bra: "Lua de abóbora",
        fre: "Lune citrouille",
        sch: "瓜月当空"
    },
    186: {
        img: "frantic_spooker",
        eng: "Frantic Spooker",
        rus: "Неистовый страшила",
        schema: 202,
        pol: "szalony straszak",
        hun: "Kétségbeesett kísértet",
        swe: "Frenetiskt spöke",
        bra: "Camarada ansioso",
        fre: "Fantôme frénétique",
        sch: "狂乱怪灵"
    },
    187: {
        img: "frightened_poltergeist",
        eng: "Frightened Poltergeist",
        rus: "Пугливый полтергейст",
        schema: 203,
        pol: "przestraszony duch",
        bra: "Poltergeist pávido",
        hun: "Rémült kísértet",
        swe: "Skrämd poltergeist",
        fre: "Ectoplasme effrayé",
        sch: "惊恐怪灵"
    },
    188: {
        img: "energetic_haunter",
        eng: "Energetic Haunter",
        rus: "Энергичный преследователь",
        schema: 204,
        pol: "energetyczna zjawa",
        hun: "Energikus kísértő",
        swe: "Energisk gast",
        bra: "Espectro energético",
        fre: "Revenant remuant",
        sch: "欢脱怪灵"
    },
    189: {
        img: "smissmas_tree",
        eng: "Smissmas Tree",
        rus: "Шмождественская ёлка",
        schema: 205,
        pol: "śniąteczne drzewko",
        bra: "Árvore de Natal",
        hun: "Galácsonyfa",
        fre: "Arbre de Smissmas",
        swe: "Smissmas-gran"
    },
    190: {
        img: "hospitable_festivity",
        eng: "Hospitable Festivity",
        rus: "Гостеприимное торжество",
        schema: 206,
        pol: "w gości na Święta",
        bra: "Festividade hospitaleira",
        hun: "Vendégszerető ünnepiesség",
        fre: "Célébration stellaire",
        swe: "Festlig gästfrihet",
        sch: "盛情欢庆"
    },
    191: {
        img: "condescending_embrace",
        eng: "Condescending Embrace",
        rus: "Снисходительное объятие",
        schema: 207,
        pol: "wzgardliwe objęcie",
        hun: "Leereszkedő ölelés",
        bra: "Condescendência acolhedora",
        fre: "Accolade condescendante",
        swe: "Nedlåtande omfamning",
        sch: "傲慢怀抱"
    },
    192: {
        img: "sparkling_spruce",
        eng: "Sparkling Spruce",
        rus: "Сверкающая сосна",
        schema: 209,
        pol: "iskrzący świerk",
        hun: "Sziporkázó luc",
        bra: "Abeto radiante",
        fre: "Épicéa étincelant",
        swe: "Glittrande gran",
        sch: "璀璨云杉"
    },
    193: {
        img: "glittering_juniper",
        eng: "Glittering Juniper",
        rus: "Блестящий можжевельник",
        schema: 210,
        pol: "lśniący jałowiec",
        hun: "Csillogó boróka",
        bra: "Jubilação junípera",
        fre: "Genévrier scintillant",
        swe: "Glittrande enbär",
        sch: "闪耀杜松"
    },
    194: {
        img: "prismatic_pine",
        eng: "Prismatic Pine",
        rus: "Призменная пихта",
        schema: 211,
        pol: "pryzmatyczna sosna",
        bra: "Pinheiro prismático",
        hun: "Színjátszó fenyő",
        fre: "Pin prismatique",
        swe: "Prismatisk gran",
        sch: "七彩冷杉"
    },
    195: {
        img: "smissmas_swirl",
        eng: "Spiraling Lights",
        rus: "Спиральная гирлянда",
        schema: 212,
        pol: "spiralne światełka",
        hun: "Forgó fények",
        swe: "Spiralljus",
        bra: "Espiral cintilante",
        fre: "Tourbillon de lumières"
    },
    196: {
        img: "twisting_lights",
        eng: "Twisting Lights",
        rus: "Вьющаяся гирлянда",
        schema: 213,
        pol: "pokręcone światełka",
        hun: "Táncoló fények",
        bra: "Sinuosidade radiante",
        fre: "Guirlande tournante",
        swe: "Snurrande ljusslinga"
    },
    197: {
        img: "stardust_pathway",
        eng: "Stardust Pathway",
        rus: "Путеводная звезда",
        schema: 214,
        pol: "gwiezdna ścieżka",
        bra: "Estrada estrelada",
        hun: "Csillagporösvény",
        fre: "Voie étoilée",
        swe: "Stjärnväg"
    },
    198: {
        img: "flurry_rush",
        eng: "Flurry Rush",
        rus: "Снежный взлёт",
        schema: 215,
        pol: "śnieżna gorączka",
        hun: "Pelyhes pukkanás",
        bra: "Estrada adornada",
        fre: "Boule de neige",
        swe: "Snöyra",
        sch: "喷薄雪花"
    },
    199: {
        img: "spark_of_smissmas",
        eng: "Spark of Smissmas",
        rus: "Шмождественская искра",
        schema: 216,
        pol: "iskra Śniąt",
        bra: "Chama do Natal",
        hun: "Galácsonyi szikra",
        fre: "Étincelle de Smissmas",
        swe: "Munter gnista"
    },
    200: {
        img: "polar_forecast",
        eng: "Polar Forecast",
        rus: "Полярная погода",
        schema: 218,
        pol: "polarna prognoza",
        bra: "Previsão polar",
        hun: "Sarkvidéki előrejelzés",
        fre: "Météo polaire",
        swe: "Polarprognos"
    },
    201: {
        img: "shining_stag",
        eng: "Shining Stag",
        rus: "Ослепительный олень",
        schema: 219,
        pol: "lśniący jeleń",
        hun: "Ragyogó rénszarvas",
        bra: "Galhada áurea",
        fre: "Cerf scintillant",
        swe: "Glänsande hjort"
    },
    202: {
        img: "holiday_horns",
        eng: "Holiday Horns",
        rus: "Развесёлые рога",
        schema: 220,
        pol: "świąteczne rogi",
        bra: "Galhada galharda",
        hun: "Ünnepi szarvak",
        fre: "Cornes festives",
        swe: "Julhorn"
    },
    203: {
        img: "ardent_antlers",
        eng: "Ardent Antlers",
        rus: "Роскошные рога",
        schema: 221,
        pol: "płomienne poroże",
        hun: "Lángagancsok",
        bra: "Galhada ardente",
        fre: "Bois brulants",
        swe: "Glödande horn"
    },
    204: {
        img: "festive_lights",
        eng: "Festive Lights",
        rus: "Праздничные лампочки",
        schema: 223,
        pol: "świąteczne światełka",
        bra: "Luzes festivas",
        hun: "Ünnepi fények",
        fre: "Lumières festives",
        swe: "Festliga ljus"
    },
    205: {
        img: "crustacean_sensation",
        eng: "Crustacean Sensation",
        rus: "Крабовые красавчики",
        schema: 224,
        pol: "sensacyjne skorupiaki",
        bra: "Sensação crustácea",
        hun: "Tengerparti érzés",
        fre: "Instant crustacé",
        swe: "Kräftskiva",
        sch: "蟹意满面"
    },
    206: {
        img: "frosted_decadence",
        eng: "Frosted Decadence",
        rus: "Гламурная глазурь",
        schema: 226,
        pol: "mroźna dekadencja",
        bra: "Decadência glacê",
        hun: "Deres dekadencia",
        fre: "Glaçage décadent",
        swe: "Frostad dekadens",
        sch: "霜落纷纷"
    },
    207: {
        img: "sprinkled_delights",
        eng: "Sprinkled Delights",
        rus: "Вкусный восторг",
        schema: 228,
        pol: "posypkowe przysmaki",
        bra: "Prazeres granulados",
        hun: "Szórt finomság",
        fre: "Sucreries saupoudrées",
        swe: "Strösselfröjd"
    },
    208: {
        img: "terrestrial_favor",
        eng: "Terrestrial Favor",
        rus: "Земные заботы",
        schema: 229,
        pol: "ziemska życzliwość",
        bra: "Benevolência terrestre",
        hun: "Földi kegy",
        fre: "Faveur terrestre",
        swe: "Galaktisk gunst",
        sch: "交织之境"
    },
    209: {
        img: "tropical_thrill",
        eng: "Tropical Thrill",
        rus: "Тропический трепет",
        schema: 230,
        pol: "tropikalny dreszcz",
        bra: "Agitação tropical",
        hun: "Trópusi izgalom",
        fre: "Frisson tropical",
        swe: "Tropisk magi",
        sch: "交织之力"
    },
    210: {
        img: "flourishing_passion",
        eng: "Flourishing Passion",
        rus: "Цветастые страсти",
        schema: 231,
        pol: "kwitnąca pasja",
        bra: "Paixão florescente",
        hun: "Virágzó szenvedély",
        fre: "Passion florissante",
        swe: "Sprakande passion",
        sch: "交织之意"
    },
    211: {
        img: "dazzling_fireworks",
        eng: "Dazzling Fireworks",
        rus: "Искристый фейерверк",
        schema: 232,
        pol: "olśniewające fajerwerki",
        bra: "Pirotecnia deslumbrante",
        hun: "Káprázatos tűzijáték",
        fre: "Feux d'artifice éblouissants",
        swe: "Bländande fyrverkerier",
        sch: "闪映爆竹"
    },
    212: {
        img: "blazing_fireworks",
        eng: "Blazing Fireworks",
        rus: "Полыхающий фейерверк",
        schema: 233,
        pol: "ogniste fajerwerki",
        bra: "Pirotecnia ardente",
        hun: "Lángoló tűzijáték",
        fre: "Feux d'artifice explosifs",
        swe: "Flammande fyrverkerier"
    },
    213: {
        img: "shimmering_fireworks",
        eng: "Shimmering Fireworks",
        rus: "Блистающий фейерверк",
        schema: 234,
        pol: "lśniące fajerwerki",
        bra: "Pirotecnia lustrosa",
        hun: "Sziporkázó tűzijáték",
        fre: "Feux d'artifice scintillants",
        swe: "Skimrande fyrverkerier",
        sch: "闪耀爆竹"
    },
    214: {
        img: "twinkling_fireworks",
        eng: "Twinkling Fireworks",
        rus: "Мерцающий фейерверк",
        schema: 235,
        pol: "migoczące fajerwerki",
        bra: "Pirotecnia reluzente",
        hun: "Pislákoló tűzijáték",
        fre: "Feux d'artifice rutilants",
        swe: "Tindrande fyrverkerier"
    },
    215: {
        img: "sparkling_fireworks",
        eng: "Sparkling Fireworks",
        rus: "Сверкающий фейерверк",
        schema: 236,
        pol: "iskrzące fajerwerki",
        bra: "Pirotecnia resplandecente",
        hun: "Szikrázó tűzijáték",
        fre: "Feux d'artifice étincelants",
        swe: "Gnistrande fyrverkerier"
    },
    216: {
        img: "glowing_fireworks",
        eng: "Glowing Fireworks",
        rus: "Сияющий фейерверк",
        schema: 237,
        pol: "jaskrawe fajerwerki",
        bra: "Pirotecnia luminosa",
        hun: "Parázsló tűzijáték",
        fre: "Feux d'artifice rayonnants",
        swe: "Glödande fyrverkerier"
    },
    217: {
        img: "glimmering_fireworks",
        eng: "Glimmering Fireworks",
        rus: "Переливчатый фейерверк",
        schema: 238,
        pol: "błyszczące fajerwerki",
        bra: "Pirotecnia cintilante",
        hun: "Fénylő tűzijáték",
        fre: "Feux d'artifice miroitants",
        swe: "Glittrande fyrverkerier",
        sch: "闪色爆竹"
    },
    218: {
        img: "flying_lights",
        eng: "Flying Lights",
        rus: "Небесные фонарики",
        schema: 239,
        pol: "latające latarnie",
        hun: "Repülő fények",
        bra: "Lanternas voadoras",
        fre: "Lanternes volantes",
        swe: "Svävande ljus",
        sch: "映福天灯"
    },
    219: {
        img: "limelight",
        eng: "Limelight",
        rus: "Зелёные огоньки",
        schema: 241,
        pol: "limonkowe latarnie",
        bra: "Holofotes",
        hun: "Reflektorfény",
        fre: "Lampions citron vert",
        swe: "Rampljus",
        sch: "寓福天灯"
    },
    220: {
        img: "shining_star",
        eng: "Shining Star",
        rus: "Сияющие звёздочки",
        schema: 242,
        pol: "lśniąca gwiazda",
        bra: "Estrela cintilante",
        hun: "Ragyogó csillag",
        fre: "Lumières orange",
        swe: "Glänsande stjärna",
        sch: "祈福天灯"
    },
    221: {
        img: "cold_cosmos",
        eng: "Cold Cosmos",
        rus: "Вечерняя вселенная",
        schema: 243,
        pol: "zimny kosmos",
        hun: "Hideg kozmosz",
        bra: "Cosmo gélido",
        fre: "Cosmos glacial",
        swe: "Kall kosmos",
        sch: "寒暮星辰"
    },
    222: {
        img: "refracting_fractals",
        eng: "Refracting Fractals",
        rus: "Флуктуация фракталов",
        schema: 244,
        pol: "fraktalne załamanie",
        bra: "Fractais refratores",
        hun: "Töredező fraktálok",
        fre: "Fractales réfractantes",
        swe: "Brytande fraktaler",
        sch: "双升螺旋"
    },
    223: {
        img: "startrance",
        eng: "Startrance",
        rus: "Звёздный час",
        schema: 245,
        pol: "gwiezdny trans",
        hun: "Csillagtransz",
        bra: "Transe astral",
        fre: "Transe stellaire",
        swe: "Stjärntrans",
        sch: "星律波纹"
    },
    224: {
        img: "starlush",
        eng: "Starlush",
        rus: "Звёздная болезнь",
        schema: 247,
        pol: "gwiezdny gaj",
        hun: "Csillagfény",
        bra: "Verdor espacial",
        fre: "Vert luisant",
        swe: "Stjärngrönska",
        sch: "星萃波纹"
    },
    225: {
        img: "stardust",
        eng: "Stardust",
        rus: "Звёздная пыль",
        schema: 249,
        pol: "gwiezdny pył",
        hun: "Csillagpor",
        bra: "Poeira cósmica",
        fre: "Poussière d'étoile",
        sch: "星尘波纹",
        swe: "Stjärnstoft"
    },
    226: {
        img: "contagious_eruption",
        eng: "Contagious Eruption",
        rus: "Вирусное извержение",
        schema: 250,
        pol: "zaraźliwa erupcja",
        hun: "Fertőző kitörés",
        bra: "Erupção epidêmica",
        fre: "Éruption contagieuse",
        swe: "Smittsamt utbrott"
    },
    227: {
        img: "daydream_eruption",
        eng: "Daydream Eruption",
        rus: "Воображённое извержение",
        schema: 251,
        pol: "senna erupcja",
        hun: "Álmodozó kitörés",
        bra: "Erupção estelar",
        fre: "Éruption onirique",
        swe: "Dagdrömsutbrott",
        sch: "梦境喷发"
    },
    228: {
        img: "volcanic_eruption",
        eng: "Volcanic Eruption",
        rus: "Вулканическое извержение",
        schema: 252,
        pol: "wulkaniczna erupcja",
        bra: "Erupção vulcânica",
        hun: "Vulkánkitörés",
        fre: "Éruption volcanique",
        swe: "Vulkanutbrott",
        sch: "熔岩喷发"
    },
    229: {
        img: "divine_sunlight",
        eng: "Divine Sunlight",
        rus: "Божественный свет",
        schema: 253,
        pol: "boskie światło",
        bra: "Alvorada divina",
        hun: "Isteni napfény",
        fre: "Soleil divin",
        swe: "Gudomliga strålar",
        sch: "神圣日光"
    },
    230: {
        img: "audiophile",
        eng: "Audiophile",
        rus: "Аудиофилия",
        schema: 254,
        pol: "audiofil",
        bra: "Audiófilo",
        hun: "Audiofil",
        swe: "Musikälskare",
        sch: "韵感声波"
    },
    231: {
        img: "soundwave",
        eng: "Soundwave",
        rus: "Звукотерапия",
        schema: 255,
        pol: "fala dźwiękowa",
        bra: "Onda sonora",
        hun: "Hanghullám",
        fre: "Fréquence sonore",
        swe: "Ljudvåg",
        sch: "动感声波"
    },
    232: {
        img: "synesthesia",
        eng: "Synesthesia",
        rus: "Синестезия",
        schema: 256,
        pol: "synestezja",
        bra: "Sinestesia",
        hun: "Szinesztézia",
        fre: "Synesthésie",
        swe: "Synestesi",
        sch: "劲感声波"
    },
    233: {
        img: "haunted_kraken",
        eng: "Haunted Kraken",
        rus: "Проклятый Кракен",
        schema: 257,
        pol: "nawiedzony Kraken",
        bra: "Kraken assombrado",
        fre: "Kraken hanté",
        hun: "Lidérces kraken",
        swe: "Hemsökt Kraken",
        sch: "海魔触须"
    },
    234: {
        img: "eerie_kraken",
        eng: "Eerie Kraken",
        rus: "Жуткий Кракен",
        schema: 258,
        bra: "Kraken sombrio",
        fre: "Kraken sinistre",
        hun: "Hajmeresztő kraken",
        pol: "upiorny Kraken",
        swe: "Kusliga Kraken",
        sch: "海妖触须"
    },
    235: {
        img: "soulful_slice",
        eng: "Soulful Slice",
        rus: "Проникновенный порез",
        schema: 259,
        bra: "Golpe gosmento",
        fre: "Une tranche d'âme",
        hun: "Szellemes fejsze",
        pol: "straszliwa siekiera",
        swe: "Spökhugg",
        sch: "断魂灵斧"
    },
    236: {
        img: "horsemanns_hack",
        eng: "Horsemann's Hack",
        rus: "Возмездие всадника",
        schema: 260,
        bra: "Corte certeiro",
        fre: "Coup de hache du cavalier sans tête",
        hun: "A Lovas csapása",
        pol: "jatka Jeźdźca",
        swe: "Horsemannens hugg",
        sch: "斩首灵斧"
    },
    237: {
        img: "haunted_forever",
        eng: "Haunted Forever!",
        rus: "Вечное проклятие!",
        schema: 261,
        pol: "wieczyste nawiedzenie",
        bra: "Assombrado para sempre!",
        fre: "Hanté à vie",
        hun: "Örökké kísértett!",
        swe: "Evigt hemsökt!",
        sch: "永劫诅咒！"
    },
    238: {
        img: "forever_and_forever",
        eng: "Forever And Forever!",
        rus: "На веки вечные!",
        schema: 263,
        pol: "już zawsze, na zawsze",
        bra: "Para todo o sempre!",
        fre: "Pour toujours et à tout jamais !",
        hun: "Örökkön örökké!",
        swe: "För evigt och för alltid!",
        sch: "永恒诅咒！"
    },
    239: {
        img: "cursed_forever",
        eng: "Cursed Forever!",
        rus: "Вечное заклятие!",
        schema: 264,
        pol: "permamentne przekleństwo",
        bra: "Amaldiçoado para sempre!",
        fre: "Maudit pour toujours !",
        hun: "Örökké átkozott!",
        swe: "Evigt förbannad!",
        sch: "永世诅咒！"
    },
    240: {
        img: "moth_plague",
        eng: "Moth Plague",
        rus: "Нашествие мотыльков",
        schema: 265,
        pol: "plaga ciem",
        bra: "Praga de mariposas",
        fre: "Nuée de papillons de nuit",
        hun: "Molyhad",
        swe: "Malpest",
        sch: "蛾疫风波"
    },
    241: {
        img: "malevolent_monoculi",
        eng: "Malevolent Monoculi",
        rus: "Гадкие Глазастусы",
        schema: 266,
        bra: "Monoculi malevolentes",
        fre: "Œil maléfique",
        hun: "Rosszakaró Monoculusok",
        pol: "mroczne Monoculusy",
        swe: "Enögd ondska",
        sch: "眼观六路"
    },
    242: {
        img: "haunted_wick",
        eng: "Haunted Wick",
        rus: "Проклятый фитиль",
        schema: 267,
        pol: "nawiedzony knot",
        bra: "Pavio assombrado",
        fre: "Mèche hantée",
        hun: "Kísérteties kanóc",
        swe: "Spökveke",
        sch: "亡灵魂火"
    },
    243: {
        img: "wicked_wick",
        eng: "Wicked Wick",
        rus: "Одержимый фитиль",
        schema: 269,
        pol: "nikczemny knot",
        bra: "Pavio perverso",
        fre: "Mèche méchante",
        hun: "Komisz kanóc",
        swe: "Vek veke",
        sch: "邪灵魂火"
    },
    244: {
        img: "spectral_wick",
        eng: "Spectral Wick",
        rus: "Призрачный фитиль",
        schema: 270,
        pol: "widmowy knot",
        bra: "Pavio espectral",
        fre: "Mèche spectrale",
        hun: "Lidérces kanóc",
        swe: "Vålnadsveke",
        sch: "幽灵魂火"
    },
    245: {
        img: "musical_maelstrom",
        eng: "Musical Maelstrom",
        rus: "Кружащая композиция",
        schema: 271,
        pol: "muzyczny mętlik",
        bra: "Turbilhão musical",
        fre: "Malström musical",
        hun: "Zenés forgatag",
        swe: "Musikalisk malström",
        sch: "音乐漩涡"
    },
    246: {
        img: "verdant_virtuoso",
        eng: "Verdant Virtuoso",
        rus: "Вечнозелёный виртуоз",
        schema: 272,
        pol: "zielony wirtuoz",
        bra: "Virtuoso verdejante",
        fre: "Virtuose verdoyant",
        hun: "Zöld virtuóz",
        swe: "Smaragdvirtuos",
        sch: "青绿艺匠"
    },
    247: {
        img: "silver_serenade",
        eng: "Silver Serenade",
        rus: "Серебряная серенада",
        schema: 273,
        pol: "srebrzysta serenada",
        bra: "Serenata prateada",
        fre: "Sérénade argentée",
        hun: "Ezüst szerenád",
        swe: "Silverserenad",
        sch: "银白夜曲"
    },
    248: {
        img: "cosmic_constellations",
        eng: "Cosmic Constellations",
        rus: "Космические созвездия",
        schema: 274,
        pol: "kosmiczne konstelacje",
        bra: "Constelações cósmicas",
        fre: "Constellations cosmiques",
        hun: "Kozmikus csillagképek",
        swe: "Kosmiska konstellationer",
        sch: "宇宙星座"
    },
    249: {
        img: "dazzling_constellations",
        eng: "Dazzling Constellations",
        rus: "Ослепительные созвездия",
        schema: 276,
        pol: "oślepiające konstelacje",
        bra: "Constelações deslumbrantes",
        fre: "Constellations éblouissantes",
        hun: "Káprázatos csillagképek",
        swe: "Förtrollande konstellationer",
        sch: "灿烂星团"
    },
    250: {
        img: "tainted_frost",
        eng: "Tainted Frost",
        rus: "Запятнанный мороз",
        schema: 277,
        pol: "skażona szadź",
        bra: "Geada manchada",
        fre: "Flocons sanglants",
        hun: "Piszkos hó",
        swe: "Förorenad frost",
        sch: "血染寒霜"
    },
    251: {
        img: "starlight_haze",
        eng: "Starlight Haze",
        rus: "Звёздный туман",
        schema: 278,
        pol: "gwiezdna mgławica",
        bra: "Neblina estelar",
        fre: "Néon nébuleux",
        hun: "Csillagfényköd",
        swe: "Stjärnljusdimma",
        sch: "星光迷雾"
    },
    252: {
        img: "hard_carry",
        eng: "Hard Carry",
        rus: "Тяжёлая ноша",
        schema: 279,
        pol: "tajna teczka",
        bra: "Carregador sonhador",
        fre: "Malette mal lunée",
        hun: "Kemény táska",
        swe: "Ryggskott",
        sch: "硬核运送"
    },
    253: {
        img: "jellyfish_field",
        eng: "Jellyfish Field",
        rus: "Поле медуз",
        schema: 281,
        pol: "mielizna meduz",
        bra: "Campo de águas-vivas",
        fre: "Champ de méduses",
        hun: "Medúzamező",
        swe: "Manetfält",
        sch: "水母秘境"
    },
    254: {
        img: "jellyfish_hunter",
        eng: "Jellyfish Hunter",
        rus: "Охотник на медуз",
        schema: 283,
        pol: "łowca meduz",
        bra: "Caçador de águas-vivas",
        fre: "Chasse-méduses",
        hun: "Medúzavadász",
        swe: "Manetjägare",
        sch: "水母捕手"
    },
    255: {
        img: "jellyfish_jam",
        eng: "Jellyfish Jam",
        rus: "Мелодия медуз",
        schema: 284,
        pol: "meduzi melanż",
        bra: "Dança das águas-vivas",
        fre: "Confiture de méduses",
        hun: "Medúzalekvár",
        swe: "Manetstoj",
        sch: "水母果酱"
    },
    256: {
        img: "global_clusters",
        eng: "Global Clusters",
        rus: "Глобальные скопления",
        schema: 285,
        pol: "gromada globalna",
        bra: "Constelação",
        fre: "Nébuleuse turquoise",
        hun: "Csillagrajok",
        swe: "Klothop",
        sch: "球状星团"
    },
    257: {
        img: "celestial_starburst",
        eng: "Celestial Starburst",
        rus: "Небесные вспышки",
        schema: 286,
        pol: "wybuch na nieboskłonie",
        bra: "Explosão estelar",
        fre: "Nébuleuse mauve",
        hun: "Égi csillagrobbanás",
        swe: "Himmelsk stjärnexplosion",
        sch: "天域星爆"
    },
    258: {
        img: "sylicone_succiduous",
        eng: "Sylicone Succiduous",
        rus: "Кремниевый крен",
        schema: 287,
        pol: "spadający silikon",
        bra: "Silício cadente",
        fre: "Nébuleuse navel",
        hun: "Narancs csillaghullás",
        sch: "硅华星流"
    },
    259: {
        img: "sakura_smoke_bomb",
        eng: "Sakura Smoke Bomb",
        rus: "Дымная сакура",
        schema: 288,
        pol: "wiśniowa bomba dymna",
        bra: "Bomba de cerejeira",
        fre: "Fumigène fleuri",
        hun: "Sakura füstbomba",
        swe: "Blomstrande rökbomb",
        sch: "樱花烟雾弹"
    },
    260: {
        img: "treasure_trove",
        eng: "Treasure Trove",
        rus: "Сыпучие сокровища",
        schema: 289,
        pol: "żyła złota",
        bra: "Baú do tesouro",
        fre: "Jackpot",
        hun: "Kincsesbánya",
        swe: "Guldgruva",
        sch: "无主宝藏"
    },
    261: {
        img: "bubble_breeze",
        eng: "Bubble Breeze",
        rus: "Полёт пузырьков",
        schema: 290,
        pol: "bąbelkowa bryza",
        bra: "Borbulho de bolhas",
        fre: "Bubulles",
        hun: "Buborékfuvallat",
        swe: "Bubbelbris",
        sch: "泡影微岚"
    },
    262: {
        img: "fireflies",
        eng: "Fireflies",
        rus: "Светлячки",
        schema: 291,
        pol: "świetliki",
        bra: "Vaga-lumes",
        fre: "Lucioles",
        hun: "Szentjánosbogarak",
        swe: "Eldflugor",
        sch: "萤火虫"
    },
    263: {
        img: "mountain_halo",
        eng: "Mountain Halo",
        rus: "Горный нимб",
        schema: 292,
        pol: "górska aureola",
        bra: "Mundo das nuvens",
        fre: "Halo alpin",
        hun: "Hegyi fénykoszorú",
        swe: "Bergsgloria",
        sch: "山峦光晕"
    },
    264: {
        img: "celestial_summit",
        eng: "Celestial Summit",
        rus: "Небесный ореол",
        schema: 293,
        pol: "niebiański szczyt",
        bra: "Cume celestial",
        fre: "Sommet céleste",
        hun: "Mennyei csúcs",
        swe: "Stjärntopp",
        sch: "星际之巅"
    },
    265: {
        img: "stellar_ascent",
        eng: "Stellar Ascent",
        rus: "Звёздный восход",
        schema: 294,
        pol: "gwiezdna wzniosłość",
        bra: "Ascensão estelar",
        fre: "Ascension stellaire",
        hun: "Sziporkázó emelkedés",
        swe: "Stjärnstigning",
        sch: "升腾星辉"
    },
    266: {
        img: "sapped",
        eng: "Sapped",
        rus: "Жертва жучка",
        schema: 295,
        pol: "zasapowany",
        bra: "Sabotado",
        fre: "Saboté",
        hun: "Mentesítve",
        swe: "Sappad",
        sch: "电子瘫痪"
    },
    267: {
        img: "hellspawned_horns",
        eng: "Hellspawned Horns",
        rus: "Адские рога",
        schema: 297,
        pol: "rogi z piekła rodem",
        bra: "Chifres diabólicos",
        fre: "Cornes diaboliques",
        hun: "Pokol szülte szarvak",
        swe: "Helvetshorn",
        sch: "地狱号角"
    },
    268: {
        img: "demonic_impaler",
        eng: "Demonic Impaler",
        rus: "Демонический бодатель",
        schema: 299,
        pol: "palownik z czeluści",
        bra: "Empaladores demoníacos",
        fre: "Empaleur démoniaque",
        hun: "Démoni nyársaló",
        swe: "Demonisk spetsare",
        sch: "恶魔贯刺"
    },
    269: {
        img: "revenants_rack",
        eng: "Revenant's Rack",
        rus: "Инфернальные наросты",
        schema: 300,
        pol: "piekielne poroże",
        bra: "Retaliação pontiaguda",
        fre: "Cornes du revenant",
        hun: "Szörnyű szarvak",
        swe: "Gengångarens taggar",
        sch: "亡魂魔角"
    },
    270: {
        img: "sixth_sense",
        eng: "Sixth Sense",
        rus: "Шестое чувство",
        schema: 301,
        pol: "szósty zmysł",
        bra: "Sexto sentido",
        fre: "Sixième sens",
        hun: "Hatodik érzék",
        swe: "Sjätte sinnet",
        sch: "第六感"
    },
    271: {
        img: "amygdala",
        eng: "Amygdala",
        rus: "Амигдала",
        schema: 303,
        pol: "ciało migdałowate",
        bra: "Amígdala",
        fre: "Amygdales",
        hun: "Amigdala",
        sch: "梦魇之眼"
    },
    272: {
        img: "the_bone_zone",
        eng: "Bone Zone",
        rus: "Черепокружение",
        schema: 304,
        pol: "strefa gnatów",
        bra: "Zona óssea",
        fre: "Crânerie",
        hun: "A csontzóna",
        rom: "The Bone Zone",
        swe: "Benzonen",
        sch: "骸骨地带"
    },
    273: {
        img: "arachnes_web",
        eng: "Arachne's Web",
        rus: "Паутина Арахны",
        schema: 305,
        pol: "pajęcza pajęczyna",
        bra: "Teia da tecelã",
        fre: "Toile d'araignée",
        hun: "Arachné hálója",
        swe: "Arachnes webb",
        sch: "诡丝迷网"
    },
    274: {
        img: "acidic_climate",
        eng: "Acidic Climate",
        rus: "Кислотный климат",
        schema: 306,
        pol: "kwaśny deszcz",
        bra: "Tempestade ácida",
        fre: "Climat acide",
        hun: "Savas éghajlat",
        swe: "Surt klimat",
        sch: "酸性气候"
    },
    275: {
        img: "otherworldly_weather",
        eng: "Otherworldly Weather",
        rus: "Потусторонняя погода",
        schema: 307,
        pol: "pogoda pozaświata",
        bra: "Tempestade cósmica",
        fre: "Météo surnaturelle",
        hun: "Túlvilági időjárás",
        swe: "Utomjordiskt väder",
        sch: "超凡天象"
    },
    276: {
        img: "nightmarish_storm",
        eng: "Nightmarish Storm",
        rus: "Ураган ужасов",
        schema: 308,
        pol: "koszmarna burza",
        bra: "Tempestade sinistra",
        fre: "Tempête cauchemardesque",
        hun: "Rémálomvihar",
        swe: "Mardrömsstorm",
        sch: "噩梦风暴"
    },
    277: {
        img: "icestruck",
        eng: "Icestruck",
        rus: "Ледяная стрела",
        schema: 309,
        pol: "lodowate uderzenie",
        bra: "Flechada gelada",
        fre: "Flèche glacée",
        hun: "Jégnyíl",
        swe: "Isträff",
        sch: "冰霜飞箭"
    },
    278: {
        img: "goldstruck",
        eng: "Goldstruck",
        rus: "Золотая стрела",
        schema: 311,
        pol: "złote uderzenie",
        bra: "Flechada dourada",
        fre: "Flèche dorée",
        hun: "Aranynyíl",
        swe: "Guldträff",
        sch: "黄金飞箭"
    },
    279: {
        img: "radiant_rivalry",
        eng: "Radiant Rivalry",
        rus: "Сияющий соперник",
        schema: 312,
        pol: "rozpromieniona rywalizacja",
        bra: "Rivalidade radiante",
        fre: "Rivalité radieuse",
        hun: "Ragyogó rivalizálás",
        swe: "Lysande rivalitet",
        sch: "耀世之争"
    },
    280: {
        img: "radiant_legacy",
        eng: "Radiant Legacy",
        rus: "Блистательное наследие",
        schema: 314,
        pol: "rozpromieniona sukcesja",
        bra: "Legado luminoso",
        fre: "Promo radieuse",
        hun: "Sugárzó hagyaték",
        swe: "Lysande arv",
        sch: "耀世遗产"
    },
    281: {
        img: "frosty_flavours",
        eng: "Frosty Flavours",
        rus: "Позёмочная присыпка",
        schema: 315,
        pol: "mroźne posmaki",
        bra: "Cérebro congelado",
        fre: "Saveurs givrées",
        hun: "Fagyos finomságok",
        swe: "Frostiga smaker",
        sch: "冰霜风味"
    },
    282: {
        img: "mint_frost",
        eng: "Mint Frost",
        rus: "Мятный мороз",
        schema: 317,
        pol: "mroźna mięta",
        bra: "Geada de menta",
        fre: "Menthe givrée",
        hun: "Deres menta",
        swe: "Mintfrost",
        sch: "冰爽薄荷"
    },
    283: {
        img: "north_star",
        eng: "North Star",
        rus: "Полярная звезда",
        schema: 318,
        pol: "Gwiazda Polarna",
        bra: "Estrela Polar",
        fre: "Étoile polaire",
        hun: "Sarkcsillag",
        swe: "Nordstjärnan",
        sch: "北极星"
    },
    284: {
        img: "prettiest_star",
        eng: "Prettiest Star",
        rus: "Прекраснейшая звезда",
        schema: 320,
        pol: "najładniejsza gwiazda",
        bra: "Estrela bela",
        fre: "Belle étoile",
        hun: "Legszebb csillag",
        swe: "Finaste stjärnan",
        sch: "璀璨明星"
    },
    285: {
        img: "festive_falling_star",
        eng: "Festive Falling Star",
        rus: "Праздничный звездопад",
        schema: 321,
        pol: "świąteczna opadająca gwiazda",
        bra: "Estrela-cadente festiva",
        fre: "Étoile filante festive",
        hun: "Ünnepi hullócsillag",
        swe: "Festligt stjärnfall",
        sch: "盛典流光"
    },
    286: {
        img: "lunar_lights",
        eng: "Lunar Lights",
        rus: "Лунные огни",
        schema: 322,
        pol: "księżycowe światełka",
        bra: "Faíscas lunares",
        fre: "Lumières lunaires",
        hun: "Holdfények",
        swe: "Månljus",
        sch: "明月之光"
    },
    287: {
        img: "fairly_lights",
        eng: "Fairy Lights",
        rus: "Сказочные огни",
        schema: 324,
        pol: "wróżkowe światełka",
        bra: "Faíscas fantásticas",
        fre: "Lumières féeriques",
        hun: "Tündérfények",
        swe: "Feljus",
        sch: "童话之光"
    },
    288: {
        img: "natural_lights",
        eng: "Natural Lights",
        rus: "Лесные огни",
        schema: 325,
        pol: "naturalne światełka",
        bra: "Faíscas naturais",
        fre: "Lumières naturelles",
        hun: "Természetes fények",
        swe: "Naturligt ljus",
        sch: "自然之光"
    },
    289: {
        img: "loyalists_coronet",
        eng: "Loyalist's Coronet",
        rus: "Коронет лоялиста",
        schema: 327,
        pol: "diadem lojalności",
        sch: "虔诚冠冕",
        bra: "Coroa do legalista",
        fre: "Diadème du loyaliste",
        hun: "A lojalista koronája",
        swe: "Lojalistens adelskrona"
    },
    290: {
        img: "knights_prideful_spirit",
        eng: "Knight's Prideful Spirit",
        rus: "Гордый дух рыцаря",
        schema: 329,
        pol: "dumny duch rycerza",
        sch: "骑士傲灵",
        bra: "Espírito orgulhoso do cavaleiro",
        fre: "Orgueil du chevalier",
        hun: "A lovag büszke szelleme",
        swe: "Riddarens stolthet"
    },
    291: {
        img: "barons_cherished_chaplet",
        eng: "Baron's Cherished Chaplet",
        rus: "Заветный венок барона",
        schema: 330,
        pol: "cenny wieniec barona",
        sch: "贵族珍冠",
        bra: "Diadema digno do barão",
        fre: "Chapelet chéri du baron",
        hun: "A báró dédelgetett füzére",
        swe: "Baronens krans"
    },
    292: {
        img: "lure_of_the_deep",
        eng: "Lure of the Deep",
        rus: "Приманка глубин",
        schema: 331,
        pol: "wabik z głębin",
        sch: "深海诱饵",
        bra: "Atração das profundezas",
        fre: "Charme des profondeurs",
        hun: "Csábító mélység",
        swe: "Djupet lockar"
    },
    293: {
        img: "violent_viridian",
        eng: "Violent Viridian",
        rus: "Изумрудный изувер",
        schema: 333,
        pol: "zdziczała zieleń",
        sch: "凶猛绿鳍",
        bra: "Violência verde",
        fre: "Viride vivace",
        hun: "Vad viridián",
        swe: "Våldsam viridian"
    },
    294: {
        img: "magenta_monstrum",
        eng: "Magenta Monstrum",
        rus: "Пурпурный палач",
        schema: 334,
        pol: "magentowe monstrum ",
        sch: "紫红怪鳍",
        bra: "Monstro magenta",
        fre: "Monstre magenta",
        swe: "Magenta-monstrum"
    },
    295: {
        img: "rainbow_reverie",
        eng: "Rainbow Reverie",
        rus: "Радужная радость",
        schema: 335,
        pol: "pryzmatyczne przemyślenia",
        sch: "彩虹幻梦",
        bra: "Devaneio multicolorido",
        fre: "Abstraction arc-en-ciel",
        hun: "Szivárványos ábránd",
        swe: "Regnbågsdröm"
    },
    296: {
        img: "cuban_smoke",
        eng: "Cuban Smoke",
        rus: "Кубинский дымок",
        schema: 336,
        pol: "kubańska zadyma",
        sch: "古巴雪茄",
        bra: "Fumaça cubana",
        fre: "Fumée cubaine",
        hun: "Kubai parázs",
        swe: "Kubansk rök"
    },
    297: {
        img: "melting_mohawk",
        eng: "Melting Mohawk",
        rus: "Испепеляющий ирокез",
        schema: 337,
        pol: "iskrzący irokez",
        sch: "熔动莫西干",
        bra: "Moicano ardente",
        fre: "Mohawk ardent",
        hun: "Olvadó taraj",
        swe: "Påtänt hår"
    },
    298: {
        img: "scorched_scalp",
        eng: "Scorched Scalp",
        rus: "Жгучий череп",
        schema: 339,
        pol: "spieczony skalp",
        sch: "头皮发热",
        bra: "Cabeça chamuscada",
        fre: "Crâne torride",
        hun: "Perzselt skalp",
        swe: "Flammande hårbotten"
    },
    299: {
        img: "ignited_crest",
        eng: "Ignited Crest",
        rus: "Тлеющее темя",
        schema: 340,
        pol: "płonący herb",
        sch: "引火羽冠",
        bra: "Crista crepitante",
        fre: "Cap incandescent",
        hun: "Kigyulladt taréj",
        swe: "Brandfarlig hjälm"
    },
    300: {
        img: "rare_shine",
        eng: "Rare Shine",
        rus: "Редкое сияние",
        schema: 341,
        pol: "niespotykany połysk",
        sch: "稀物闪耀",
        bra: "Brilho raro",
        fre: "Tête dans les étoiles",
        hun: "Ritka ragyogás",
        swe: "Sällsynt glans"
    },
    301: {
        img: "distant_drift",
        eng: "Distant Drift",
        rus: "Дальний дрейф",
        schema: 342,
        pol: "daleki dryf",
        sch: "漂泊羁旅",
        bra: "Deriva distante",
        fre: "Glorieuse galaxie",
        hun: "Kozmikus csillagtenger",
        swe: "Avlägsen drift"
    },
    302: {
        img: "warp_drive",
        eng: "Warp Drive",
        rus: "Варп-двигатель",
        schema: 344,
        pol: "napęd nadświetlny",
        sch: "曲速引擎",
        bra: "Dobra espacial",
        fre: "Distorsion gravitationnelle",
        hun: "Fénysebesség",
        swe: "Tidsresa"
    },
    303: {
        img: "overdrive",
        eng: "Overdrive",
        rus: "Овердрайв",
        schema: 345,
        pol: "nadbieg",
        sch: "超负荷",
        bra: "Sobrecarga",
        fre: "Hyperdéformation",
        hun: "Űrsebesség",
        swe: "Överbelastning"
    },
    304: {
        img: "butterfly_season",
        eng: "Butterfly Season",
        rus: "Сезон бабочек",
        schema: 346,
        pol: "sezon na motylki",
        sch: "蝴蝶热季",
        bra: "Temporada de borboletas",
        fre: "Papillons palpitants",
        hun: "Pillangószezon",
        swe: "Fjärilsäsong"
    },
    305: {
        img: "psycho_delic",
        eng: "Psycho-delic",
        rus: "Психо-делия",
        schema: 348,
        pol: "kwiatogenny",
        sch: "精神迷幻",
        bra: "Psico-délico",
        fre: "Psychodélique",
        hun: "Pszicho-delikus",
        swe: "Psykodelisk"
    },
    306: {
        img: "bewitching_bugs",
        eng: "Bewitching Bugs",
        rus: "Обаятельные бабочки",
        schema: 349,
        pol: "urzekające owady",
        sch: "迷人飞虫",
        bra: "Belas borboletas",
        fre: "Insectes irréels",
        hun: "Elbűvölő bogarak",
        swe: "Förtrollade fjärilar"
    },
    307: {
        img: "spectral_fire",
        eng: "Spectral Fire",
        rus: "Спектральный огонь",
        schema: 350,
        pol: "widmowy ogień",
        sch: "幻影魂火",
        bra: "Fogo espectral",
        fre: "Feu spectral",
        hun: "Lidérces láng",
        swe: "Vålnadseld"
    },
    308: {
        img: "galactic_flame",
        eng: "Galactic Flame",
        rus: "Галактическое пламя",
        schema: 351,
        pol: "galaktyczny płomień",
        sch: "银河之火",
        bra: "Chama galática",
        fre: "Nuée galactique",
        hun: "Galaktikus láng",
        swe: "Galaktisk låga"
    },
    309: {
        img: "revived_recharge",
        eng: "Revived Recharge",
        rus: "Реанимирующий разряд",
        schema: 352,
        pol: "wyładowanie wskrzeszonego",
        sch: "回生充能",
        bra: "Recarga revivida",
        fre: "Décharge réanimatrice",
        hun: "Újraéledt újratöltés",
        swe: "Återladdad"
    },
    310: {
        img: "frankencharged",
        eng: "Frankencharged",
        rus: "Франкеншторм",
        schema: 353,
        pol: "frankennaładowany",
        sch: "爆能怪人",
        bra: "Frankarregado",
        fre: "Frankencharge",
        hun: "Frankentöltve",
        swe: "Frankenladdad"
    },
    311: {
        img: "undead_electricity",
        eng: "Undead Electricity",
        rus: "Энергия нежити",
        schema: 354,
        pol: "elektryczność nieumarłego",
        sch: "不死电流",
        bra: "Eletricidade morta-viva",
        fre: "Électricité macabre",
        hun: "Élőhalott elektromosság",
        swe: "Vandöd elektricitet"
    },
    312: {
        img: "phantom_plague",
        eng: "Phantom Plague",
        rus: "Трупный туман",
        schema: 355,
        pol: "przywidziana plaga",
        sch: "幻影瘟疫",
        bra: "Praga fantasma",
        fre: "Peste fantôme",
        hun: "Fantompestis",
        swe: "Fantompest"
    },
    313: {
        img: "haunting_haze",
        eng: "Haunting Haze",
        rus: "Проклятая пелена",
        schema: 356,
        pol: "nawiedzona mgła",
        sch: "阴霾萦绕",
        bra: "Névoa assombrada",
        fre: "Fumée maudite",
        hun: "Kísértő köd",
        swe: "Hemsökt dimma"
    },
    314: {
        img: "vicious_vampires",
        eng: "Vicious Vampires",
        rus: "Мыши-мучители",
        schema: 357,
        pol: "wściekłe wampiry",
        sch: "凶残血蝠",
        bra: "Vampiros vis",
        fre: "Vampires vicieux",
        hun: "Veszedelmes vámpírok",
        swe: "Bitska vampyrer"
    },
    315: {
        img: "ravenous_ravens",
        eng: "Ravenous Ravens",
        rus: "Вороватые вороны",
        schema: 358,
        pol: "wygłodniałe wrony",
        sch: "饥饿黑鸦",
        bra: "Corvos carniceiros",
        fre: "Corbeaux carnassiers",
        hun: "Harapós hollók",
        swe: "Glupska korpar"
    },
    316: {
        img: "delightful_doves",
        eng: "Delightful Doves",
        rus: "Грациозные голуби",
        schema: 359,
        pol: "gołębia gloria",
        sch: "欢愉白鸽",
        bra: "Pombas pacíficas",
        fre: "Colombes conciliantes",
        hun: "Gáláns galambok",
        swe: "Ljuvliga duvor"
    },
    317: {
        img: "searing_stove",
        eng: "Searing Stove",
        rus: "Пылающая плита",
        schema: 360,
        pol: "palący palnik",
        sch: "灼热炉火",
        bra: "Fogão flamejante",
        fre: "Gazinière d'artifice",
        hun: "Perzselő tűzhely",
        swe: "Osande spis"
    },
    318: {
        img: "uber_blaze",
        eng: "Über Blaze",
        rus: "Убер-запал",
        schema: 362,
        pol: "überżar",
        sch: "超能炫光",
        bra: "Überraios",
        fre: "Über ardent",
        hun: "Überláng",
        swe: "Überlåga"
    },
    319: {
        img: "sizzling",
        eng: "Sizzling",
        schema: 364,
        pol: "skwierczenie",
        sch: "滋滋冒气",
        bra: "Escaldante",
        fre: "Brulant",
        hun: "Sistergő",
        swe: "Rykande",
        rus: "Обжарка"
    },
    320: {
        img: "crystal_crown",
        eng: "Crystal Crown",
        schema: 365,
        pol: "kryształowa korona",
        sch: "水晶王冠",
        bra: "Coroa de cristal",
        fre: "Couronne de cristal",
        hun: "Kristálykorona",
        swe: "Kristallkrona",
        rus: "Кристальная корона"
    },
    321: {
        img: "halcyon_halo",
        eng: "Halcyon Halo",
        schema: 367,
        pol: "cudowna aureola",
        sch: "太平光环",
        bra: "Auréola pacífica",
        fre: "Halo merveilleux",
        hun: "Boldog glória",
        swe: "Salig gloria",
        rus: "Невозмутимый нимб"
    },
    322: {
        img: "ghosts_of_smissmas_time",
        eng: "Ghosts of Smissmas Time",
        schema: 368,
        pol: "duch śniąt",
        sch: "圣诞众灵",
        bra: "Fantasmas das festividades",
        fre: "Fantômes de Smissmas",
        hun: "Galácsonyi szellemek",
        swe: "Smissmas andar",
        rus: "Духи Шмождества"
    },
    323: {
        img: "aurora_skies",
        eng: "Aurora Skies",
        schema: 369,
        pol: "zorzowe niebo",
        sch: "极地夜空",
        bra: "Céus auroreais",
        fre: "Ciel boréal",
        hun: "Auróra égbolt",
        swe: "Polarsky",
        rus: "Полярные небеса"
    },
    324: {
        img: "shining_bokeh",
        eng: "Shining Bokeh",
        schema: 370,
        pol: "błyszczące rozmycie",
        sch: "闪亮散焦",
        bra: "Bokeh brilhante",
        fre: "Bokeh brillant",
        hun: "Fénylő bokréta",
        swe: "Glänsande bokeh",
        rus: "Блестящее боке"
    },
    325: {
        img: "playful_aurora",
        eng: "Playful Aurora",
        schema: 371,
        pol: "zorzowa zabawa",
        sch: "欢腾极光",
        bra: "Aurora brincalhona",
        fre: "Aurore espiègle",
        hun: "Játékos auróra",
        swe: "Lekfull aurora",
        rus: "Игривое сияние"
    },
    326: {
        img: "frisky_morning",
        eng: "Frisky Morning",
        schema: 372,
        pol: "rozbrykany poranek",
        sch: "蓬勃朝气",
        bra: "Manhã animada",
        fre: "Matin fringant",
        hun: "Csípős reggel",
        swe: "Frisk morgon",
        rus: "Резвое утро"
    },
    327: {
        img: "drunkard",
        eng: "Drunkard",
        schema: 373,
        pol: "moczymorda",
        sch: "酩酊大醉",
        bra: "Bebum",
        fre: "Ivresse",
        hun: "Iszákos",
        swe: "Fyllbult",
        rus: "Пьяница"
    },
    328: {
        img: "blades_of_betrayal",
        eng: "Blades of Betrayal",
        schema: 374,
        pol: "ostrza zdrady",
        sch: "背叛之刃",
        bra: "Lâminas da traição",
        fre: "Dagues déloyales",
        hun: "Az árulás pengéi",
        swe: "Hundra hugg",
        rus: "Кинжалы коварства"
    },
    329: {
        img: "deaths_daggers",
        eng: "Death's Daggers",
        schema: 376,
        pol: "sztylety śmierci",
        sch: "死神匕首",
        bra: "Punhais apunhalados",
        fre: "Lames lugubres",
        hun: "Halálos tőrök",
        swe: "Dödens dolkar",
        rus: "Пронзающая погибель"
    },
    330: {
        img: "fully_charged",
        eng: "Fully Charged",
        schema: 377,
        pol: "w pełni naładowany",
        sch: "能量爆棚",
        bra: "Carga completa",
        fre: "Chargé à bloc",
        hun: "Teljesen feltöltve",
        swe: "Maxladdad",
        rus: "Полный заряд"
    },
    331: {
        img: "overcharged",
        eng: "Overcharged",
        schema: 379,
        pol: "przeładowany",
        sch: "超量充能",
        bra: "Sobrecarga",
        fre: "Surcharge",
        hun: "Túltöltve",
        swe: "Överladdad",
        rus: "Сверхзаряд"
    },
    332: {
        img: "piercing_headache",
        eng: "Piercing Headache",
        schema: 380,
        pol: "przeszywający ból głowy",
        sch: "脑洞大开",
        bra: "Enxaqueca perfurante",
        fre: "Migraine mortelle",
        hun: "Szúró fejfájás",
        swe: "Genomborrande huvudvärk",
        rus: "Мимолётная мигрень"
    },
    333: {
        img: "decimating_wind",
        eng: "Decimating Wind",
        schema: 381,
        pol: "niszczycielska wichura",
        sch: "风卷残云",
        bra: "Tornado de tubarões",
        fre: "Bourrasque brutale",
        hun: "Cápatornádó",
        swe: "Vansinnig vindstyrka",
        rus: "Пагубный ветер"
    },
    334: {
        img: "ocean_swirl",
        eng: "Ocean Swirl",
        schema: 382,
        pol: "oceaniczny wir",
        sch: "大洋漩涡",
        bra: "Redemoinho",
        fre: "Tourbillon océanique",
        hun: "Óceáni örvény",
        swe: "Havsvirvel",
        rus: "Океанское завихрение"
    },
    335: {
        img: "toxic_swirl",
        eng: "Toxic Swirl",
        schema: 384,
        pol: "toksyczny wir",
        sch: "剧毒漩涡",
        bra: "Venenoinho",
        fre: "Tourbillon toxique",
        hun: "Mérgező örvény",
        swe: "Giftvirvel",
        rus: "Токсичное завихрение"
    },
    336: {
        img: "candle_flame",
        eng: "Candle Flame",
        schema: 385,
        pol: "płomień świecy",
        sch: "摇曳烛火",
        bra: "Fogo de vela",
        fre: "Flamme de bougie",
        hun: "Gyertyaláng",
        swe: "Ljuslåga",
        rus: "Пламя свечи"
    },
    337: {
        img: "sizzling_aroma",
        eng: "Sizzling Aroma",
        schema: 387,
        pol: "skwierczący aromat",
        sch: "滋油喷香",
        bra: "Aroma ardente",
        fre: "Arôme flambé",
        hun: "Sistergő aroma",
        swe: "Rykande arom",
        rus: "Обжигающий аромат"
    },
    338: {
        img: "toxic_aroma",
        eng: "Toxic Aroma",
        schema: 389,
        pol: "toksyczny aromat",
        sch: "毒液迷臭",
        bra: "Aroma tóxico",
        fre: "Arôme toxique",
        hun: "Mérgező aroma",
        swe: "Giftig arom",
        rus: "Токсичный аромат"
    },
    339: {
        img: "current_conductor",
        eng: "Current Conductor",
        schema: 390,
        pol: "przewodnik prądu",
        sch: "电流导体",
        bra: "Condutor de corrente",
        fre: "Conducteur de courant",
        hun: "Áramvezető",
        swe: "Strömledare",
        rus: "Переменчивый проводник"
    },
    340: {
        img: "sandy",
        eng: "Sandy",
        schema: 392,
        pol: "piaskowiec",
        sch: "灰头土脸",
        bra: "Arenoso",
        fre: "Sableux",
        hun: "Homokos",
        swe: "Sandig",
        rus: "Песочник"
    },
    341: {
        img: "chromatic_blaze",
        eng: "Chromatic Blaze",
        schema: 393,
        pol: "chromatyczny płomień",
        sch: "炫彩烈焰",
        bra: "Chama cromática",
        fre: "Flamme chromatique",
        hun: "Kromatikus láng",
        swe: "Kromatisk eld",
        rus: "Хроматическое пламя"
    },
    342: {
        img: "frostfire",
        eng: "Frostfire",
        schema: 394,
        pol: "lodowy płomień",
        sch: "霜冻之火",
        bra: "Fogo frio",
        fre: "Flamme boréale",
        hun: "Fagytűz",
        swe: "Frostflamma",
        rus: "Ледяной огонь"
    },
    343: {
        img: "spectrum_inferno",
        eng: "Spectrum Inferno",
        schema: 395,
        pol: "piekielne spektrum",
        sch: "光谱燃烧",
        bra: "Inferno espectral",
        fre: "Brasier prismatique",
        hun: "Spektrális tűzvész",
        swe: "Spektralinferno",
        rus: "Спектральное пылание"
    },
    344: {
        img: "calm_snowfall",
        eng: "Calm Snowfall",
        schema: 396,
        pol: "prószący śnieg",
        sch: "宁静飘雪",
        bra: "Neve tranquila",
        fre: "Neige calme",
        hun: "Nyugodt hóesés",
        swe: "Stilla snöfall",
        rus: "Спокойный снегопад"
    },
    345: {
        img: "team_recognition",
        eng: "Team Recognition",
        schema: 397,
        pol: "przedstawienie drużyny",
        sch: "团队认证",
        bra: "Reconhecimento da equipe",
        fre: "Marque d'équipe",
        hun: "Csapatelismerés",
        swe: "Laguppvisning",
        rus: "Признание команды"
    },
    346: {
        img: "old_hire",
        eng: "Old Hire",
        schema: 399,
        pol: "stary wyjadacz",
        sch: "资深老辈",
        bra: "Contratado clássico",
        fre: "Vieux de la vieille",
        hun: "Öreg róka",
        swe: "Gammalt kontrakt",
        rus: "Бывалый наёмник"
    },
    347: {
        img: "analog_fortress",
        eng: "Analog Fortress",
        schema: 401,
        pol: "analogowa forteca",
        sch: "模拟要塞",
        bra: "Fortaleza analógica",
        fre: "TF analogique",
        swe: "Analog fästning",
        rus: "Аналоговый логотип"
    },
    348: {
        img: "winter_whiteout",
        eng: "Winter Whiteout",
        schema: 402,
        pol: "zimowa biel",
        sch: "冬日白昼",
        bra: "Nevasca invernal",
        fre: "Manteau de neige",
        hun: "Téli fehérség",
        swe: "Snöflingor",
        rus: "Морозная мгла"
    },
    349: {
        img: "midnight_frostfall",
        eng: "Midnight Frostfall",
        schema: 403,
        pol: "północny przymrozek",
        sch: "午夜霜华",
        bra: "Geada da meia-noite",
        fre: "Gelée de minuit",
        hun: "Éjféli fagy",
        swe: "Midnattsfrost",
        rus: "Полуночный мороз"
    },
    350: {
        img: "twilight_snowfall",
        eng: "Twilight Snowfall",
        schema: 404,
        pol: "śnieżek o zmierzchu",
        sch: "暮色落雪",
        bra: "Neve do anoitecer",
        fre: "Neige crépusculaire",
        hun: "Alkonyi hóesés",
        swe: "Skymningssnöfall",
        rus: "Сумеречная метель"
    },
    351: {
        img: "cryogenic",
        eng: "Cryogenic",
        schema: 405,
        pol: "kriogenika",
        sch: "低温冷冻",
        bra: "Criogênico",
        fre: "Cryogel",
        hun: "Mélyhűtött",
        swe: "Kryogen",
        rus: "Криоген"
    },
    352: {
        img: "umbral_lights",
        eng: "Umbral Lights",
        schema: 407,
        sch: "本影夜光",
        bra: "Luzes na escuridão",
        hun: "Elmosódott fények",
        swe: "Skuggljus",
        rus: "Смутное сияние",
        pol: "cieniste światła",
        fre: "Lueurs lilas"
    },
    353: {
        img: "polar_prism",
        eng: "Polar Prism",
        schema: 408,
        sch: "极地棱镜",
        bra: "Prisma polar",
        hun: "Sarki prizma",
        swe: "Polarprism",
        rus: "Полярная призма",
        cze: "Northern Nights",
        rom: "Northern Nights",
        pol: "polarny pryzmat",
        fre: "Prisme polaire"
    },
    354: {
        img: "solar_singed",
        eng: "Solar Singed",
        schema: 409,
        sch: "日光灼烧",
        bra: "Queimadura solar",
        hun: "Napperzselte",
        swe: "Solsvedd",
        rus: "Солнечное сверкание",
        pol: "słoneczna spalenizna",
        fre: "Radiation solaire"
    },
    355: {
        img: "floral_growth",
        eng: "Floral Growth",
        schema: 410,
        sch: "花卉丛生",
        hun: "Virágözön",
        rus: "Цвет-расцвет",
        pol: "kwiecisty rozrost",
        bra: "Crescimento floral",
        fre: "Croissance florale",
        swe: "Blomsterprakt"
    },
    356: {
        img: "stellar_orbit",
        eng: "Stellar Orbit",
        schema: 412,
        sch: "坠星轨道",
        hun: "Csillagpálya",
        rus: "Звёздная орбита",
        pol: "gwiezdna orbita",
        bra: "Órbita estelar",
        fre: "Orbite stellaire",
        swe: "Omloppsbana"
    },
    357: {
        img: "blissful_butterflies",
        eng: "Blissful Butterflies",
        schema: 413,
        sch: "极乐飞蝶",
        bra: "Borboletas bonitas",
        hun: "Boldog pillangók",
        swe: "Förnöjda fjärilar",
        rus: "Блаженные бабочки",
        pol: "milusie motylki",
        fre: "Papillons prodigieux"
    },
    358: {
        img: "wispful_wings",
        eng: "Wispful Wings",
        schema: 415,
        sch: "飘逸仙灵",
        bra: "Asas espirituais",
        hun: "Leheletfinom szárnyak",
        swe: "Vindsvepta vingar",
        rus: "Волшебные взмахи",
        pol: "stęsknione skrzydełka",
        fre: "Lépidospectre"
    },
    359: {
        img: "flor_de_muerto",
        eng: "Flor de Muerto",
        schema: 416
    },
    360: {
        img: "autumn_breeze",
        eng: "Autumn Breeze",
        schema: 418
    },
    361: {
        img: "spirit_swirl",
        eng: "Spirit Swirl",
        schema: 419
    },
    362: {
        img: "ghost_swirl",
        eng: "Ghost Swirl",
        schema: 420
    },
    363: {
        img: "fable_feathers",
        eng: "Fable Feathers",
        schema: 421
    },
    364: {
        img: "fable_quills",
        eng: "Fable Quills",
        schema: 423
    },
    365: {
        img: "grudge_n_drudge",
        eng: "Grudge n' Drudge",
        schema: 424
    },
    366: {
        img: "boil_n_toil",
        eng: "Boil n' Toil",
        schema: 425
    },
    367: {
        img: "screaming_soul",
        eng: "Screaming Soul",
        schema: 426
    },
    368: {
        img: "screeching_soul",
        eng: "Screeching Soul",
        schema: 427
    },
    369: {
        img: "shrieking_soul",
        eng: "Shrieking Soul",
        schema: 428
    }
}